import { zGraphemeString } from '../../../../validation/grapheme';
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAS Online Clinic Backend API
 * SASオンラインクリニックのバックエンドAPI仕様。分割YAML構成で管理し、RedoclyとSpectralで検証します。
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * 患者IDに対応する詳細情報を返します。
 *
 * 認証済みユーザーのロールがpatient-user（患者）の場合、指定したpatientIdに関わらず、自身の患者情報を返します。
 *
 * 認証済みユーザーのロールがpatient-admin（企業管理者）の場合、同じ組織に所属する患者情報のみ取得可能です。
 *
 * 認証済みユーザーのロールがclinic-doctor（医師）またはclinic-operator（医療事務）の場合、自身の医療機関に通院する患者情報のみ取得可能です。
 *
 * 認証済みユーザーのロールがops-admin（NTTBS管理者）またははops-operator（オペレーター）の場合、全ての患者情報を取得可能です。
 * @summary 患者の詳細情報を取得する
 */
export const PatientGetDetailParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientGetDetailResponseOneNameMax = 100;

export const patientGetDetailResponseOneNameKanaMax = 200;

export const patientGetDetailResponseOneOrganizationNameMax = 200;

export const patientGetDetailResponseOneOrganizationHierarchyItemNameMax = 200;

export const patientGetDetailResponseOneOrganizationHierarchyItemDepthMin = 0;


export const patientGetDetailResponseOneEmployeeNumberOneMax = 50;

export const patientGetDetailResponseOneEmailOneMin = 5;
export const patientGetDetailResponseOneEmailOneMax = 254;

export const patientGetDetailResponseOnePhoneNumberOneMin = 10;
export const patientGetDetailResponseOnePhoneNumberOneMax = 20;


export const patientGetDetailResponseOnePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientGetDetailResponseOnePostalAddressPrefectureOneMax = 50;

export const patientGetDetailResponseOnePostalAddressMunicipalityOneMax = 100;

export const patientGetDetailResponseOnePostalAddressStreetAddressOneMax = 300;

export const patientGetDetailResponseOnePostalAddressBuildingOneMax = 200;

export const patientGetDetailResponseOnePostalAddressPostalCodeOneMax = 8;


export const patientGetDetailResponseOnePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientGetDetailResponseTwoNameMax = 100;

export const patientGetDetailResponseTwoNameKanaMax = 200;

export const patientGetDetailResponseTwoOrganizationNameMax = 200;

export const patientGetDetailResponseTwoOrganizationHierarchyItemNameMax = 200;

export const patientGetDetailResponseTwoOrganizationHierarchyItemDepthMin = 0;


export const patientGetDetailResponseTwoEmployeeNumberOneMax = 50;

export const patientGetDetailResponseTwoEmailOneMin = 5;
export const patientGetDetailResponseTwoEmailOneMax = 254;

export const patientGetDetailResponseTwoPhoneNumberOneMin = 10;
export const patientGetDetailResponseTwoPhoneNumberOneMax = 20;


export const patientGetDetailResponseTwoPhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientGetDetailResponseTwoPostalAddressPrefectureOneMax = 50;

export const patientGetDetailResponseTwoPostalAddressMunicipalityOneMax = 100;

export const patientGetDetailResponseTwoPostalAddressStreetAddressOneMax = 300;

export const patientGetDetailResponseTwoPostalAddressBuildingOneMax = 200;

export const patientGetDetailResponseTwoPostalAddressPostalCodeOneMax = 8;


export const patientGetDetailResponseTwoPostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientGetDetailResponseThreeNameMax = 100;

export const patientGetDetailResponseThreeNameKanaMax = 200;

export const patientGetDetailResponseThreeOrganizationNameMax = 200;

export const patientGetDetailResponseThreeOrganizationHierarchyItemNameMax = 200;

export const patientGetDetailResponseThreeOrganizationHierarchyItemDepthMin = 0;


export const patientGetDetailResponseThreeEmployeeNumberOneMax = 50;

export const patientGetDetailResponseThreeEmailOneMin = 5;
export const patientGetDetailResponseThreeEmailOneMax = 254;

export const patientGetDetailResponseThreePhoneNumberOneMin = 10;
export const patientGetDetailResponseThreePhoneNumberOneMax = 20;


export const patientGetDetailResponseThreePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientGetDetailResponseThreePostalAddressPrefectureOneMax = 50;

export const patientGetDetailResponseThreePostalAddressMunicipalityOneMax = 100;

export const patientGetDetailResponseThreePostalAddressStreetAddressOneMax = 300;

export const patientGetDetailResponseThreePostalAddressBuildingOneMax = 200;

export const patientGetDetailResponseThreePostalAddressPostalCodeOneMax = 8;


export const patientGetDetailResponseThreePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');


export const PatientGetDetailResponse = zod.union([zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetDetailResponseOneNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientGetDetailResponseOneNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientGetDetailResponseOneOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetDetailResponseOneOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientGetDetailResponseOneOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseOneEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientGetDetailResponseOneEmailOneMin).max(patientGetDetailResponseOneEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientGetDetailResponseOnePhoneNumberOneMin, max: patientGetDetailResponseOnePhoneNumberOneMax }).refine((v) => patientGetDetailResponseOnePhoneNumberOneRegExp.test(v)),zod.null()]).describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseOnePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseOnePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseOnePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseOnePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientGetDetailResponseOnePostalAddressPostalCodeOneMax }).refine((v) => patientGetDetailResponseOnePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict(),zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetDetailResponseTwoNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientGetDetailResponseTwoNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientGetDetailResponseTwoOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetDetailResponseTwoOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientGetDetailResponseTwoOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseTwoEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientGetDetailResponseTwoEmailOneMin).max(patientGetDetailResponseTwoEmailOneMax),zod.null()]).describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientGetDetailResponseTwoPhoneNumberOneMin, max: patientGetDetailResponseTwoPhoneNumberOneMax }).refine((v) => patientGetDetailResponseTwoPhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseTwoPostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseTwoPostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseTwoPostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseTwoPostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientGetDetailResponseTwoPostalAddressPostalCodeOneMax }).refine((v) => patientGetDetailResponseTwoPostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()]).and(zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetDetailResponseThreeNameMax }).describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientGetDetailResponseThreeNameKanaMax }).describe('ふりがな'),
  "birthday": zod.string().date().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientGetDetailResponseThreeOrganizationNameMax }).describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetDetailResponseThreeOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientGetDetailResponseThreeOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseThreeEmployeeNumberOneMax }),zod.null()]).describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientGetDetailResponseThreeEmailOneMin).max(patientGetDetailResponseThreeEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientGetDetailResponseThreePhoneNumberOneMin, max: patientGetDetailResponseThreePhoneNumberOneMax }).refine((v) => patientGetDetailResponseThreePhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseThreePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseThreePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseThreePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientGetDetailResponseThreePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientGetDetailResponseThreePostalAddressPostalCodeOneMax }).refine((v) => patientGetDetailResponseThreePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()).describe('患者の詳細情報')

/**
 * 患者の氏名/連絡先/住所/所属などのプロフィール情報を部分更新します（指定項目のみ更新）。
 *
 * 認証済みユーザーのロールがpatient-user（患者）の場合、指定したpatientIdに関わらず、自身の患者情報を更新します。
 *
 * 認証済みユーザーのロールがops-admin（NTTBS管理者）またははops-operator（オペレーター）の場合、全ての患者情報を更新可能です。
 *
 * 認証済みユーザーのロールがそれ以外の場合、更新は許可されません。
 * @summary 患者プロフィールを更新する
 */
export const PatientUpdateProfileParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientUpdateProfileBodyNameMax = 100;

export const patientUpdateProfileBodyNameKanaMax = 200;


export const patientUpdateProfileBodyNameKanaRegExp = new RegExp('^[ァ-ヶー　 ]+$');
export const patientUpdateProfileBodyEmailTwoMax = 254;

export const patientUpdateProfileBodyPhoneNumberTwoMin = 10;
export const patientUpdateProfileBodyPhoneNumberTwoMax = 20;


export const patientUpdateProfileBodyPhoneNumberTwoRegExp = new RegExp('^[0-9]+$');
export const patientUpdateProfileBodyPostalAddressTwoPrefectureMax = 50;

export const patientUpdateProfileBodyPostalAddressTwoMunicipalityMax = 100;

export const patientUpdateProfileBodyPostalAddressTwoStreetAddressMax = 300;

export const patientUpdateProfileBodyPostalAddressTwoBuildingTwoMax = 200;

export const patientUpdateProfileBodyPostalAddressTwoPostalCodeMin = 7;
export const patientUpdateProfileBodyPostalAddressTwoPostalCodeMax = 8;


export const patientUpdateProfileBodyPostalAddressTwoPostalCodeRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientUpdateProfileBodyOrganizationNameTwoMax = 200;



export const PatientUpdateProfileBody = zod.object({
  "name": zGraphemeString({ min: 1, max: patientUpdateProfileBodyNameMax }).optional().describe('氏名。\n- 未指定: 現値維持\n- `null`: 不可（422）\n- 非空文字: 指定値で上書き\n'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateProfileBodyNameKanaMax }).refine((v) => patientUpdateProfileBodyNameKanaRegExp.test(v)).optional().describe('ふりがな（全角カタカナ）。\n- 未指定: 現値維持\n- `null`: 不可（422）\n- 非空文字: 指定値で上書き\n'),
  "email": zod.union([zod.null(),zod.string().email().min(1).max(patientUpdateProfileBodyEmailTwoMax)]).optional().describe('連絡用メールアドレス。\n- 未指定: 現値維持\n- `null`: `NULL` クリア\n- 非空文字: 指定値で上書き\n'),
  "phoneNumber": zod.union([zod.null(),zGraphemeString({ min: patientUpdateProfileBodyPhoneNumberTwoMin, max: patientUpdateProfileBodyPhoneNumberTwoMax }).refine((v) => patientUpdateProfileBodyPhoneNumberTwoRegExp.test(v))]).optional().describe('連絡用電話番号。\n- 未指定: 現値維持\n- `null`: `NULL` クリア\n- 非空文字: 指定値で上書き\n'),
  "postalAddress": zod.union([zod.null(),zod.object({
  "prefecture": zGraphemeString({ min: 1, max: patientUpdateProfileBodyPostalAddressTwoPrefectureMax }).optional().describe('都道府県（自由入力）。\n- 未指定: 現値維持\n- `null`: 不可（422）\n- 非空文字: 指定値で上書き（空文字は不可）\n'),
  "municipality": zGraphemeString({ min: 1, max: patientUpdateProfileBodyPostalAddressTwoMunicipalityMax }).optional().describe('市区町村（郡・町・村等を含む、自由入力）。\n- 未指定: 現値維持\n- `null`: 不可（422）\n- 非空文字: 指定値で上書き（空文字は不可）\n'),
  "streetAddress": zGraphemeString({ min: 1, max: patientUpdateProfileBodyPostalAddressTwoStreetAddressMax }).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。\n- 未指定: 現値維持\n- `null`: 不可（422）\n- 非空文字: 指定値で上書き（空文字は不可）\n'),
  "building": zod.union([zod.null(),zGraphemeString({ min: 1, max: patientUpdateProfileBodyPostalAddressTwoBuildingTwoMax })]).optional().describe('建物名・階・号室等（任意）。\n- 未指定: 現値維持\n- `null`: `NULL` クリア\n- 非空文字: 指定値で上書き\n'),
  "postalCode": zGraphemeString({ min: patientUpdateProfileBodyPostalAddressTwoPostalCodeMin, max: patientUpdateProfileBodyPostalAddressTwoPostalCodeMax }).refine((v) => patientUpdateProfileBodyPostalAddressTwoPostalCodeRegExp.test(v)).optional().describe('郵便番号（ハイフンあり/なし両対応）。\n- 未指定: 現値維持\n- `null`: 不可（422）\n- 非空文字の場合はパターン検証が適用されます（空文字は不可）\n')
}).strict()]).optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n各フィールドは個別にDBカラムへ保存されます。\n- オブジェクト自体が `null` または未指定の場合、住所フィールドは更新されません。\n- 各フィールドのセマンティクスは上記と同様です。\n'),
  "organizationName": zod.union([zod.null(),zGraphemeString({ max: patientUpdateProfileBodyOrganizationNameTwoMax })]).optional().describe('所属企業名（読み取り専用参考情報、更新対象外）。\nこのフィールドは更新リクエストに含めても無視されます。\n')
}).strict().describe('患者プロフィール更新リクエスト（部分更新）。いずれか1つ以上のフィールドを指定する必要があります。\n\n**更新セマンティクス:**\n- 未指定: 現値を維持（更新しない）\n- nullable 項目（`email` / `phoneNumber` / `postalAddress.building`）の `null`: `NULL` へクリア\n- 非nullable 項目の `null`: `422 Unprocessable Entity`\n- 非空文字: 指定値で上書き\n- 空文字: 文字列値として扱い、各項目の制約（minLength/pattern）で検証\n\nすべてのフィールドが未指定の場合は `422 Unprocessable Entity` を返します。\n')

export const patientUpdateProfileResponseOneNameMax = 100;

export const patientUpdateProfileResponseOneNameKanaMax = 200;

export const patientUpdateProfileResponseOneOrganizationNameMax = 200;

export const patientUpdateProfileResponseOneOrganizationHierarchyItemNameMax = 200;

export const patientUpdateProfileResponseOneOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateProfileResponseOneEmployeeNumberOneMax = 50;

export const patientUpdateProfileResponseOneEmailOneMin = 5;
export const patientUpdateProfileResponseOneEmailOneMax = 254;

export const patientUpdateProfileResponseOnePhoneNumberOneMin = 10;
export const patientUpdateProfileResponseOnePhoneNumberOneMax = 20;


export const patientUpdateProfileResponseOnePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateProfileResponseOnePostalAddressPrefectureOneMax = 50;

export const patientUpdateProfileResponseOnePostalAddressMunicipalityOneMax = 100;

export const patientUpdateProfileResponseOnePostalAddressStreetAddressOneMax = 300;

export const patientUpdateProfileResponseOnePostalAddressBuildingOneMax = 200;

export const patientUpdateProfileResponseOnePostalAddressPostalCodeOneMax = 8;


export const patientUpdateProfileResponseOnePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientUpdateProfileResponseTwoNameMax = 100;

export const patientUpdateProfileResponseTwoNameKanaMax = 200;

export const patientUpdateProfileResponseTwoOrganizationNameMax = 200;

export const patientUpdateProfileResponseTwoOrganizationHierarchyItemNameMax = 200;

export const patientUpdateProfileResponseTwoOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateProfileResponseTwoEmployeeNumberOneMax = 50;

export const patientUpdateProfileResponseTwoEmailOneMin = 5;
export const patientUpdateProfileResponseTwoEmailOneMax = 254;

export const patientUpdateProfileResponseTwoPhoneNumberOneMin = 10;
export const patientUpdateProfileResponseTwoPhoneNumberOneMax = 20;


export const patientUpdateProfileResponseTwoPhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateProfileResponseTwoPostalAddressPrefectureOneMax = 50;

export const patientUpdateProfileResponseTwoPostalAddressMunicipalityOneMax = 100;

export const patientUpdateProfileResponseTwoPostalAddressStreetAddressOneMax = 300;

export const patientUpdateProfileResponseTwoPostalAddressBuildingOneMax = 200;

export const patientUpdateProfileResponseTwoPostalAddressPostalCodeOneMax = 8;


export const patientUpdateProfileResponseTwoPostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientUpdateProfileResponseThreeNameMax = 100;

export const patientUpdateProfileResponseThreeNameKanaMax = 200;

export const patientUpdateProfileResponseThreeOrganizationNameMax = 200;

export const patientUpdateProfileResponseThreeOrganizationHierarchyItemNameMax = 200;

export const patientUpdateProfileResponseThreeOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateProfileResponseThreeEmployeeNumberOneMax = 50;

export const patientUpdateProfileResponseThreeEmailOneMin = 5;
export const patientUpdateProfileResponseThreeEmailOneMax = 254;

export const patientUpdateProfileResponseThreePhoneNumberOneMin = 10;
export const patientUpdateProfileResponseThreePhoneNumberOneMax = 20;


export const patientUpdateProfileResponseThreePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateProfileResponseThreePostalAddressPrefectureOneMax = 50;

export const patientUpdateProfileResponseThreePostalAddressMunicipalityOneMax = 100;

export const patientUpdateProfileResponseThreePostalAddressStreetAddressOneMax = 300;

export const patientUpdateProfileResponseThreePostalAddressBuildingOneMax = 200;

export const patientUpdateProfileResponseThreePostalAddressPostalCodeOneMax = 8;


export const patientUpdateProfileResponseThreePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');


export const PatientUpdateProfileResponse = zod.union([zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateProfileResponseOneNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateProfileResponseOneNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateProfileResponseOneOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateProfileResponseOneOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateProfileResponseOneOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseOneEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateProfileResponseOneEmailOneMin).max(patientUpdateProfileResponseOneEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateProfileResponseOnePhoneNumberOneMin, max: patientUpdateProfileResponseOnePhoneNumberOneMax }).refine((v) => patientUpdateProfileResponseOnePhoneNumberOneRegExp.test(v)),zod.null()]).describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseOnePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseOnePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseOnePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseOnePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateProfileResponseOnePostalAddressPostalCodeOneMax }).refine((v) => patientUpdateProfileResponseOnePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict(),zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateProfileResponseTwoOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateProfileResponseTwoEmailOneMin).max(patientUpdateProfileResponseTwoEmailOneMax),zod.null()]).describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateProfileResponseTwoPhoneNumberOneMin, max: patientUpdateProfileResponseTwoPhoneNumberOneMax }).refine((v) => patientUpdateProfileResponseTwoPhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoPostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoPostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoPostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseTwoPostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateProfileResponseTwoPostalAddressPostalCodeOneMax }).refine((v) => patientUpdateProfileResponseTwoPostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()]).and(zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreeNameMax }).describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreeNameKanaMax }).describe('ふりがな'),
  "birthday": zod.string().date().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreeOrganizationNameMax }).describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreeOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateProfileResponseThreeOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreeEmployeeNumberOneMax }),zod.null()]).describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateProfileResponseThreeEmailOneMin).max(patientUpdateProfileResponseThreeEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateProfileResponseThreePhoneNumberOneMin, max: patientUpdateProfileResponseThreePhoneNumberOneMax }).refine((v) => patientUpdateProfileResponseThreePhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateProfileResponseThreePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateProfileResponseThreePostalAddressPostalCodeOneMax }).refine((v) => patientUpdateProfileResponseThreePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()).describe('患者の詳細情報')

/**
 * 患者IDに対応する従業員の担当保健師の割り付け状況（保健師1〜3の3スロット分）を返します。
 *
 * RBAC:
 * - 許可: patient-admin/health-nurse のみ（対象患者の所属組織が呼び出し元の readable_organization_ids に含まれる場合に限る）
 * @summary 従業員の担当保健師の割り付けを取得する
 */
export const PatientGetHealthNurseAssignmentsParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientGetHealthNurseAssignmentsResponseAssignmentsItemSlotMax = 3;

export const patientGetHealthNurseAssignmentsResponseAssignmentsMin = 3;
export const patientGetHealthNurseAssignmentsResponseAssignmentsMax = 3;



export const PatientGetHealthNurseAssignmentsResponse = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "assignments": zod.array(zod.object({
  "slot": zod.number().int().min(1).max(patientGetHealthNurseAssignmentsResponseAssignmentsItemSlotMax).describe('スロット番号（保健師1〜3のいずれか）'),
  "healthNurseUserId": zod.union([zod.string().uuid(),zod.null()]).describe('割り付けられている保健師のユーザーID（UUID）。未設定の場合はnull'),
  "healthNurseName": zod.union([zod.string(),zod.null()]).describe('割り付けられている保健師の氏名。未設定の場合はnull')
}).strict().describe('従業員の担当保健師の1スロット分の割り付け状況')).min(patientGetHealthNurseAssignmentsResponseAssignmentsMin).max(patientGetHealthNurseAssignmentsResponseAssignmentsMax).describe('スロット1・2・3の順で、常に3件を返す')
}).strict().describe('従業員の担当保健師の割り付け状況（3スロット分）')

/**
 * 患者IDに対応する従業員の担当保健師の割り付け（保健師1〜3の3スロット分）をまとめて一括更新します。
 * 各スロットの healthNurseUserId に null を指定するとそのスロットの割り付けを解除（未設定に）できます。
 *
 * RBAC:
 * - 許可: patient-admin/health-nurse のみ（対象患者の所属組織が呼び出し元の readable_organization_ids に含まれる場合に限る）
 * - 割り付ける healthNurseUserId は、呼び出し元から見える保健師候補（GET /api/health-nurses と同じ組織スコープ）に含まれている必要がある
 * @summary 従業員の担当保健師の割り付けを更新する
 */
export const PatientUpdateHealthNurseAssignmentsParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientUpdateHealthNurseAssignmentsBodyAssignmentsItemSlotMax = 3;

export const patientUpdateHealthNurseAssignmentsBodyAssignmentsMin = 3;
export const patientUpdateHealthNurseAssignmentsBodyAssignmentsMax = 3;



export const PatientUpdateHealthNurseAssignmentsBody = zod.object({
  "assignments": zod.array(zod.object({
  "slot": zod.number().int().min(1).max(patientUpdateHealthNurseAssignmentsBodyAssignmentsItemSlotMax).describe('スロット番号（保健師1〜3のいずれか）'),
  "healthNurseUserId": zod.union([zod.string().uuid(),zod.null()]).describe('割り付ける保健師のユーザーID（UUID）。未設定にする場合はnullを指定する')
}).strict().describe('従業員の担当保健師の1スロット分の更新指定')).min(patientUpdateHealthNurseAssignmentsBodyAssignmentsMin).max(patientUpdateHealthNurseAssignmentsBodyAssignmentsMax).describe('必ずスロット1・2・3をそれぞれちょうど1件ずつ、合計3件指定する')
}).strict().describe('従業員の担当保健師の割り付け更新リクエスト（スロット1・2・3をまとめて一括更新する）')

export const patientUpdateHealthNurseAssignmentsResponseAssignmentsItemSlotMax = 3;

export const patientUpdateHealthNurseAssignmentsResponseAssignmentsMin = 3;
export const patientUpdateHealthNurseAssignmentsResponseAssignmentsMax = 3;



export const PatientUpdateHealthNurseAssignmentsResponse = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "assignments": zod.array(zod.object({
  "slot": zod.number().int().min(1).max(patientUpdateHealthNurseAssignmentsResponseAssignmentsItemSlotMax).describe('スロット番号（保健師1〜3のいずれか）'),
  "healthNurseUserId": zod.union([zod.string().uuid(),zod.null()]).describe('割り付けられている保健師のユーザーID（UUID）。未設定の場合はnull'),
  "healthNurseName": zod.union([zod.string(),zod.null()]).describe('割り付けられている保健師の氏名。未設定の場合はnull')
}).strict().describe('従業員の担当保健師の1スロット分の割り付け状況')).min(patientUpdateHealthNurseAssignmentsResponseAssignmentsMin).max(patientUpdateHealthNurseAssignmentsResponseAssignmentsMax).describe('スロット1・2・3の順で、常に3件を返す')
}).strict().describe('従業員の担当保健師の割り付け状況（3スロット分）')

/**
 * 認証済みユーザーの権限に応じた患者一覧を返します。clinic-doctor/clinic-operator のみアクセス可能で、所属組織にスコープされます（単一グループ前提）。
 * 認証済みユーザーの権限がオペレーターであれば、
 * - organizationをパラメーターで指定しない場合、すべての患者一覧を返します。
 * - organizationをパラメーターで指定した場合、指定された医療機関もしくは企業に所属する患者一覧を返します。
 *
 * 認証済みユーザーの権限が医療機関の場合、
 * - clinicOrganizationの有無に関わらず、自組織に通院する患者一覧を返します。
 * - patientOrganizationをパラメーターで指定した場合、自組織に通院する患者のうち、指定された企業に所属する患者一覧を返します。
 *
 * 認証済みユーザーの権限が企業（patient-admin）の場合、
 * - patientOrganizationの有無に関わらず、自組織に所属する患者一覧を返します。
 * - clinicOrganizationをパラメーターで指定した場合、自組織に所属する患者のうち、指定された医療機関に通院する患者一覧を返します。
 *
 * 例:
 * - オペレーター: 全患者一覧を取得
 *   ```bash
 *   curl -H "Authorization: Bearer <operator-token>" \
 *     "/api/patients?page=0&size=20&sort=createdAt,desc"
 *   ```
 * - オペレーター: 企業でフィルタ（name指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <operator-token>" \
 *     "/api/patients?patientOrganization[name]=さすケア株式会社&page=0&size=20&sort=createdAt,desc"
 *   ```
 * - オペレーター: 医療機関でフィルタ（id指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <operator-token>" \
 *     "/api/patients?clinicOrganization[id]=11111111-2222-3333-4444-555555555555&page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 医療機関権限: 自組織通院の患者一覧
 *   ```bash
 *   curl -H "Authorization: Bearer <clinic-token>" \
 *     "/api/patients?page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 医療機関権限: 指定企業に所属する通院患者のみ（id指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <clinic-token>" \
 *     "/api/patients?patientOrganization[id]=9e4b2a2b-1234-5678-9abc-def012345678&page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 企業権限: 自社所属の患者一覧
 *   ```bash
 *   curl -H "Authorization: Bearer <company-token>" \
 *     "/api/patients?page=0&size=20&sort=createdAt,desc"
 *   ```
 * - 企業権限: 指定医療機関に通院する自社患者のみ（name指定）
 *   ```bash
 *   curl -H "Authorization: Bearer <company-token>" \
 *     "/api/patients?clinicOrganization[name]=さすケアクリニック&page=0&size=20&sort=createdAt,desc"
 *   ```
 *
 * 制限事項:
 * - patient-user は本エンドポイントへアクセスできません（403）。本人の詳細は `/api/patients/{patientId}/detail` を利用してください。
 *
 * RBAC簡易注記:
 * - 許可: `ops-*`, `clinic-*`, `patient-admin`
 * - 禁止: `patient-user`
 *
 * オプションのフリー検索:
 * - nameKana: 患者名（ふりがな）の部分一致検索に使用します。
 * - phoneNumber: 電話番号の部分一致検索に使用します。
 * - patientLocalId: 患者識別番号（医療機関独自の番号）の部分一致検索に使用します。
 * - status: 患者ステータスで絞り込みに使用します。
 * - patientOrganization: 所属企業名の部分一致検索に使用します。
 * - employeeNumber: 従業員番号の部分一致検索に使用します（patient-admin向け一覧でのみ有効）。
 * - pulseResultGrade / pulsePerformedYear / psgResultFinding / cpapTreatmentStatus / currentMonthVisitStatus:
 *   検査結果・受診状況の絞り込みに使用します（patient-admin向け一覧でのみ有効）。
 * - healthNurseUserId: 指定した保健師が担当保健師1〜3のいずれかのスロットに割り付けられている従業員に絞り込みます（patient-admin向け一覧でのみ有効）。
 * - currentMonthAhiMin / currentMonthAhiMax / currentMonthUsageRateMin / currentMonthUsageRateMax /
 *   currentMonthAverageUsageTimeMin / currentMonthAverageUsageTimeMax / previousMonthAhiMin /
 *   previousMonthAhiMax / previousMonthUsageRateMin / previousMonthUsageRateMax /
 *   previousMonthAverageUsageTimeMin / previousMonthAverageUsageTimeMax:
 *   当月/前月のAHI・装着率・平均使用時間の範囲で絞り込みに使用します（patient-admin向け一覧でのみ有効）。
 *   該当する暦月の実績サマリーが無い従業員は、これらのいずれかを指定すると結果から除外されます。
 *
 * ソート仕様:
 * - 許可されるソート列は `createdAt|updatedAt|name|id` のみです。
 * - 方向は `asc|desc` を指定してください。
 * @summary 患者一覧を取得する
 */
export const patientListPatientsQueryPageDefault = 0;
export const patientListPatientsQueryPageMin = 0;

export const patientListPatientsQuerySizeDefault = 20;
export const patientListPatientsQuerySizeMax = 2000;

export const patientListPatientsQuerySortDefault = `createdAt,desc`;

export const patientListPatientsQueryNameMax = 200;

export const patientListPatientsQueryNameKanaMax = 200;

export const patientListPatientsQueryEmailMax = 254;

export const patientListPatientsQueryPhoneNumberMin = 6;
export const patientListPatientsQueryPhoneNumberMax = 20;

export const patientListPatientsQueryPatientLocalIdMax = 100;

export const patientListPatientsQueryEmployeeNumberMax = 50;

export const patientListPatientsQueryPulsePerformedYearRegExp = new RegExp('^[0-9]{4}$');
export const patientListPatientsQueryCurrentMonthAhiMinMin = 0;

export const patientListPatientsQueryCurrentMonthAhiMaxMin = 0;

export const patientListPatientsQueryCurrentMonthUsageRateMinMin = 0;

export const patientListPatientsQueryCurrentMonthUsageRateMaxMin = 0;

export const patientListPatientsQueryCurrentMonthAverageUsageTimeMinMin = 0;

export const patientListPatientsQueryCurrentMonthAverageUsageTimeMaxMin = 0;

export const patientListPatientsQueryPreviousMonthAhiMinMin = 0;

export const patientListPatientsQueryPreviousMonthAhiMaxMin = 0;

export const patientListPatientsQueryPreviousMonthUsageRateMinMin = 0;

export const patientListPatientsQueryPreviousMonthUsageRateMaxMin = 0;

export const patientListPatientsQueryPreviousMonthAverageUsageTimeMinMin = 0;

export const patientListPatientsQueryPreviousMonthAverageUsageTimeMaxMin = 0;



export const PatientListPatientsQueryParams = zod.object({
  "page": zod.number().int().min(patientListPatientsQueryPageMin).default(patientListPatientsQueryPageDefault).describe('取得ページ番号（0開始）'),
  "size": zod.number().int().min(1).max(patientListPatientsQuerySizeMax).default(patientListPatientsQuerySizeDefault).describe('1ページあたりの件数'),
  "sort": zod.string().default(patientListPatientsQuerySortDefault).describe('ソートキー（例: createdAt,desc）'),
  "patientOrganization": zod.union([zod.object({
  "id": zod.string().uuid()
}).strict(),zod.object({
  "name": zGraphemeString({ min: 1 })
}).strict()]).optional().describe('患者フィルタ用の所属組織（id または name のいずれかを指定）'),
  "clinicOrganization": zod.union([zod.object({
  "id": zod.string().uuid()
}).strict(),zod.object({
  "name": zGraphemeString({ min: 1 })
}).strict()]).optional().describe('クリニックフィルタ用の所属組織（id または name のいずれかを指定）'),
  "name": zGraphemeString({ min: 1, max: patientListPatientsQueryNameMax }).optional().describe('患者名（漢字）の部分一致検索に使用します'),
  "nameKana": zGraphemeString({ min: 1, max: patientListPatientsQueryNameKanaMax }).optional().describe('患者名（ふりがな）での部分一致検索に使用します。'),
  "email": zGraphemeString({ min: 1, max: patientListPatientsQueryEmailMax }).optional().describe('メールアドレスの部分一致検索に使用します。'),
  "phoneNumber": zGraphemeString({ min: patientListPatientsQueryPhoneNumberMin, max: patientListPatientsQueryPhoneNumberMax }).optional().describe('電話番号の部分一致検索に使用します。'),
  "phase": zod.string().optional().describe('患者治療フェーズでの絞り込みに使用します。'),
  "status": zod.string().optional().describe('患者ステータスでの絞り込みに使用します。'),
  "patientLocalId": zGraphemeString({ min: 1, max: patientListPatientsQueryPatientLocalIdMax }).optional().describe('患者識別番号（医療機関独自の番号）の部分一致検索に使用します。'),
  "employeeNumber": zGraphemeString({ min: 1, max: patientListPatientsQueryEmployeeNumberMax }).optional().describe('従業員番号（企業が付与する識別子）の部分一致検索に使用します。patient-admin向け一覧でのみ有効です。'),
  "pulseResultGrade": zod.enum(['incomplete', 'a', 'b', 'c', 'd', 'e']).optional().describe('パルス検査結果のグレードで絞り込みに使用します（ODIから算出）。patient-admin向け一覧でのみ有効です。'),
  "pulsePerformedYear": zod.string().refine((v) => patientListPatientsQueryPulsePerformedYearRegExp.test(v)).optional().describe('パルス検査の実施年（直近1件）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。'),
  "psgResultFinding": zod.enum(['incomplete', 'no-findings', 'follow-up', 'treatment-recommended', 'cpap', 'non-cpap']).optional().describe('PSG検査結果の所見で絞り込みに使用します（直近1件の診断）。patient-admin向け一覧でのみ有効です。'),
  "cpapTreatmentStatus": zod.enum(['selecting-provider', 'pre-treatment-cancel', 'in-progress', 'discontinued', 'out-of-scope']).optional().describe('CPAP治療状況で絞り込みに使用します。patient-admin向け一覧でのみ有効です。'),
  "currentMonthVisitStatus": zod.enum(['unreserved', 'reserved', 'completed']).optional().describe('当月の受診状況（予約有無・実施有無）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。'),
  "healthNurseUserId": zod.string().uuid().optional().describe('指定した保健師が担当保健師1〜3のいずれかのスロットに割り付けられている従業員に絞り込みます。patient-admin向け一覧でのみ有効です。'),
  "currentMonthAhiMin": zod.number().min(patientListPatientsQueryCurrentMonthAhiMinMin).optional().describe('当月のAHI（平均AHI）の下限（この値以上）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。'),
  "currentMonthAhiMax": zod.number().min(patientListPatientsQueryCurrentMonthAhiMaxMin).optional().describe('当月のAHI（平均AHI）の上限（この値以下）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。'),
  "currentMonthUsageRateMin": zod.number().min(patientListPatientsQueryCurrentMonthUsageRateMinMin).optional().describe('当月の装着率の下限（この値以上）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員、または装着率が未登録の従業員は、この値を指定すると結果から除外されます。'),
  "currentMonthUsageRateMax": zod.number().min(patientListPatientsQueryCurrentMonthUsageRateMaxMin).optional().describe('当月の装着率の上限（この値以下）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員、または装着率が未登録の従業員は、この値を指定すると結果から除外されます。'),
  "currentMonthAverageUsageTimeMin": zod.number().min(patientListPatientsQueryCurrentMonthAverageUsageTimeMinMin).optional().describe('当月の平均使用時間の下限（この値以上）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。'),
  "currentMonthAverageUsageTimeMax": zod.number().min(patientListPatientsQueryCurrentMonthAverageUsageTimeMaxMin).optional().describe('当月の平均使用時間の上限（この値以下）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。'),
  "previousMonthAhiMin": zod.number().min(patientListPatientsQueryPreviousMonthAhiMinMin).optional().describe('前月のAHI（平均AHI）の下限（この値以上）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。'),
  "previousMonthAhiMax": zod.number().min(patientListPatientsQueryPreviousMonthAhiMaxMin).optional().describe('前月のAHI（平均AHI）の上限（この値以下）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。'),
  "previousMonthUsageRateMin": zod.number().min(patientListPatientsQueryPreviousMonthUsageRateMinMin).optional().describe('前月の装着率の下限（この値以上）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員、または装着率が未登録の従業員は、この値を指定すると結果から除外されます。'),
  "previousMonthUsageRateMax": zod.number().min(patientListPatientsQueryPreviousMonthUsageRateMaxMin).optional().describe('前月の装着率の上限（この値以下）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員、または装着率が未登録の従業員は、この値を指定すると結果から除外されます。'),
  "previousMonthAverageUsageTimeMin": zod.number().min(patientListPatientsQueryPreviousMonthAverageUsageTimeMinMin).optional().describe('前月の平均使用時間の下限（この値以上）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。'),
  "previousMonthAverageUsageTimeMax": zod.number().min(patientListPatientsQueryPreviousMonthAverageUsageTimeMaxMin).optional().describe('前月の平均使用時間の上限（この値以下）で絞り込みに使用します。patient-admin向け一覧でのみ有効です。該当する暦月のCPAP治療実績サマリーが無い従業員は、この値を指定すると結果から除外されます。')
}).strict()

export const patientListPatientsResponseItemsItemNameMax = 100;

export const patientListPatientsResponseItemsItemNameKanaMax = 200;

export const patientListPatientsResponseItemsItemOrganizationNameMax = 200;

export const patientListPatientsResponseItemsItemOrganizationHierarchyItemNameMax = 200;

export const patientListPatientsResponseItemsItemOrganizationHierarchyItemDepthMin = 0;


export const patientListPatientsResponseItemsItemClinicNameOneMax = 200;

export const patientListPatientsResponseItemsItemTotalInvoiceAmountMin = 0;
export const patientListPatientsResponseItemsItemTotalInvoiceAmountMax = 100000000;
export const patientListPatientsResponseItemsItemTotalInvoiceAmountMultipleOf = 1;

export const patientListPatientsResponseItemsItemPatientLocalIdOneMax = 100;

export const patientListPatientsResponseItemsItemEmployeeNumberOneMax = 50;

export const patientListPatientsResponsePagePageMin = 0;

export const patientListPatientsResponsePageSizeMax = 2000;

export const patientListPatientsResponsePageTotalElementsMin = 0;

export const patientListPatientsResponsePageTotalPagesMin = 0;



export const PatientListPatientsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid().describe('ユーザーID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientListPatientsResponseItemsItemNameMax }).describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientListPatientsResponseItemsItemNameKanaMax }).describe('ふりがな'),
  "organizationName": zGraphemeString({ min: 1, max: patientListPatientsResponseItemsItemOrganizationNameMax }).describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientListPatientsResponseItemsItemOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientListPatientsResponseItemsItemOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "clinicName": zod.union([zGraphemeString({ min: 1, max: patientListPatientsResponseItemsItemClinicNameOneMax }),zod.null()]).describe('通院先医療機関名（未設定時はnull）'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('Pulse検査ステータス（pulseStatusMaster 由来）'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('PG検査ステータス（pgStatusMaster 由来）'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).describe('PSG検査ステータス（psgStatusMaster 由来）'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).describe('CPAP治療ステータス（cpapStatusMaster 由来）'),
  "totalInvoiceAmount": zod.number().min(patientListPatientsResponseItemsItemTotalInvoiceAmountMin).max(patientListPatientsResponseItemsItemTotalInvoiceAmountMax).multipleOf(patientListPatientsResponseItemsItemTotalInvoiceAmountMultipleOf).describe('その患者に請求された金額の累計（通貨: JPY・税込）'),
  "latestPsgDiagnosis": zod.union([zod.object({
  "consultationDatetime": zod.string().datetime({"offset":true}).describe('診療日時（RFC3339）'),
  "clinicalFindings": zod.union([zod.enum(['no_findings', 'observation_required', 'treatment_recommended', 'treatment_required', 'treatment_required_cpap', 'treatment_required_non_cpap', 'pre_treatment_cancelled', 'new', 'prescription_change', 'device_change', 'mask_change', 'completed', 'treatment_started', 'no_change', 'stopped', 'resumed']),zod.null()]).describe('臨床所見（未登録時はnull）')
}).strict().describe('PSG検査かつ診断結果登録済みの診察のうち、最新のものの診療日時と臨床所見'),zod.null()]).describe('PSG検査かつ診断結果登録済みの診察のうち、最新の診療日時と臨床所見（該当する診察がない場合はnull）'),
  "latestPsgTestReport": zod.union([zod.object({
  "checkupPerformedOn": zod.string().date().nullable().describe('検査実施日（未設定時はnull）'),
  "ahi": zod.number().nullable().describe('AHI（未設定時はnull）')
}).strict().describe('最新のPSG検査テストレポートの検査実施日とAHI値'),zod.null()]).describe('最新のPSG検査テストレポートの検査実施日とAHI値（該当するレポートがない場合はnull）'),
  "latestPulseTestReport": zod.union([zod.object({
  "checkupPerformedOn": zod.string().date().nullable().describe('検査実施日（未設定時はnull）'),
  "odi": zod.number().nullable().describe('ODI（未設定時はnull）')
}).strict().describe('最新のパルス検査テストレポートの検査実施日とODI値'),zod.null()]).describe('最新のパルス検査テストレポートの検査実施日とODI値（該当するレポートがない場合はnull）'),
  "latestVisitDate": zod.string().date().nullable().describe('診断結果登録済み（有効な予約に紐づく診察記録が存在する）のうち、最新の受診日（該当する診察がない場合はnull）'),
  "patientLocalId": zod.union([zGraphemeString({ min: 1, max: patientListPatientsResponseItemsItemPatientLocalIdOneMax }),zod.null()]).optional().describe('現在の通院先クリニックにおける患者識別番号（診察券番号）。未設定時はnull'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientListPatientsResponseItemsItemEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子）。未設定時はnull。一部の一覧取得（patient-admin向け）でのみ返却する'),
  "currentMonthCpapTreatmentSummary": zod.union([zod.object({
  "avgAhi": zod.number().describe('平均AHI（回/時）'),
  "usageRate": zod.number().nullable().describe('装着率（%、未設定時はnull）'),
  "avgUsageHours": zod.number().describe('平均使用時間（時間）')
}).strict().describe('患者一覧向けのCPAP治療実績サマリー（平均AHI・装着率・平均使用時間）'),zod.null()]).optional().describe('当月（本日が属する暦月、Asia/Tokyo基準）のCPAP治療実績サマリー。該当する登録が無い場合はnull。一部の一覧取得（patient-admin向け）でのみ返却する'),
  "previousMonthCpapTreatmentSummary": zod.union([zod.object({
  "avgAhi": zod.number().describe('平均AHI（回/時）'),
  "usageRate": zod.number().nullable().describe('装着率（%、未設定時はnull）'),
  "avgUsageHours": zod.number().describe('平均使用時間（時間）')
}).strict().describe('患者一覧向けのCPAP治療実績サマリー（平均AHI・装着率・平均使用時間）'),zod.null()]).optional().describe('前月（当月の1つ前の暦月）のCPAP治療実績サマリー。該当する登録が無い場合はnull。一部の一覧取得（patient-admin向け）でのみ返却する'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者一覧の項目')),
  "page": zod.object({
  "page": zod.number().int().min(patientListPatientsResponsePagePageMin).describe('現在のページ番号（0開始）'),
  "size": zod.number().int().min(1).max(patientListPatientsResponsePageSizeMax).describe('1ページあたりの件数'),
  "totalElements": zod.number().int().min(patientListPatientsResponsePageTotalElementsMin).describe('全要素数'),
  "totalPages": zod.number().int().min(patientListPatientsResponsePageTotalPagesMin).describe('全ページ数'),
  "hasNext": zod.boolean().describe('次のページがあるか'),
  "hasPrevious": zod.boolean().describe('前のページがあるか')
}).strict().describe('ページングメタ情報')
}).strict()

/**
 * 認証済みユーザーに紐づく患者の基本情報（PatientDetail）を返します。patientIdは認証コンテキストから解決されます。
 * @summary 患者本人の基本情報を取得する
 */
export const patientGetMyDetailResponseOneNameMax = 100;

export const patientGetMyDetailResponseOneNameKanaMax = 200;

export const patientGetMyDetailResponseOneOrganizationNameMax = 200;

export const patientGetMyDetailResponseOneOrganizationHierarchyItemNameMax = 200;

export const patientGetMyDetailResponseOneOrganizationHierarchyItemDepthMin = 0;


export const patientGetMyDetailResponseOneEmployeeNumberOneMax = 50;

export const patientGetMyDetailResponseOneEmailOneMin = 5;
export const patientGetMyDetailResponseOneEmailOneMax = 254;

export const patientGetMyDetailResponseOnePhoneNumberOneMin = 10;
export const patientGetMyDetailResponseOnePhoneNumberOneMax = 20;


export const patientGetMyDetailResponseOnePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientGetMyDetailResponseOnePostalAddressPrefectureOneMax = 50;

export const patientGetMyDetailResponseOnePostalAddressMunicipalityOneMax = 100;

export const patientGetMyDetailResponseOnePostalAddressStreetAddressOneMax = 300;

export const patientGetMyDetailResponseOnePostalAddressBuildingOneMax = 200;

export const patientGetMyDetailResponseOnePostalAddressPostalCodeOneMax = 8;


export const patientGetMyDetailResponseOnePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientGetMyDetailResponseTwoNameMax = 100;

export const patientGetMyDetailResponseTwoNameKanaMax = 200;

export const patientGetMyDetailResponseTwoOrganizationNameMax = 200;

export const patientGetMyDetailResponseTwoOrganizationHierarchyItemNameMax = 200;

export const patientGetMyDetailResponseTwoOrganizationHierarchyItemDepthMin = 0;


export const patientGetMyDetailResponseTwoEmployeeNumberOneMax = 50;

export const patientGetMyDetailResponseTwoEmailOneMin = 5;
export const patientGetMyDetailResponseTwoEmailOneMax = 254;

export const patientGetMyDetailResponseTwoPhoneNumberOneMin = 10;
export const patientGetMyDetailResponseTwoPhoneNumberOneMax = 20;


export const patientGetMyDetailResponseTwoPhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientGetMyDetailResponseTwoPostalAddressPrefectureOneMax = 50;

export const patientGetMyDetailResponseTwoPostalAddressMunicipalityOneMax = 100;

export const patientGetMyDetailResponseTwoPostalAddressStreetAddressOneMax = 300;

export const patientGetMyDetailResponseTwoPostalAddressBuildingOneMax = 200;

export const patientGetMyDetailResponseTwoPostalAddressPostalCodeOneMax = 8;


export const patientGetMyDetailResponseTwoPostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientGetMyDetailResponseThreeNameMax = 100;

export const patientGetMyDetailResponseThreeNameKanaMax = 200;

export const patientGetMyDetailResponseThreeOrganizationNameMax = 200;

export const patientGetMyDetailResponseThreeOrganizationHierarchyItemNameMax = 200;

export const patientGetMyDetailResponseThreeOrganizationHierarchyItemDepthMin = 0;


export const patientGetMyDetailResponseThreeEmployeeNumberOneMax = 50;

export const patientGetMyDetailResponseThreeEmailOneMin = 5;
export const patientGetMyDetailResponseThreeEmailOneMax = 254;

export const patientGetMyDetailResponseThreePhoneNumberOneMin = 10;
export const patientGetMyDetailResponseThreePhoneNumberOneMax = 20;


export const patientGetMyDetailResponseThreePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientGetMyDetailResponseThreePostalAddressPrefectureOneMax = 50;

export const patientGetMyDetailResponseThreePostalAddressMunicipalityOneMax = 100;

export const patientGetMyDetailResponseThreePostalAddressStreetAddressOneMax = 300;

export const patientGetMyDetailResponseThreePostalAddressBuildingOneMax = 200;

export const patientGetMyDetailResponseThreePostalAddressPostalCodeOneMax = 8;


export const patientGetMyDetailResponseThreePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');


export const PatientGetMyDetailResponse = zod.union([zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetMyDetailResponseOneNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientGetMyDetailResponseOneNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientGetMyDetailResponseOneOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetMyDetailResponseOneOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientGetMyDetailResponseOneOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseOneEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientGetMyDetailResponseOneEmailOneMin).max(patientGetMyDetailResponseOneEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientGetMyDetailResponseOnePhoneNumberOneMin, max: patientGetMyDetailResponseOnePhoneNumberOneMax }).refine((v) => patientGetMyDetailResponseOnePhoneNumberOneRegExp.test(v)),zod.null()]).describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseOnePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseOnePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseOnePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseOnePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientGetMyDetailResponseOnePostalAddressPostalCodeOneMax }).refine((v) => patientGetMyDetailResponseOnePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict(),zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientGetMyDetailResponseTwoOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientGetMyDetailResponseTwoEmailOneMin).max(patientGetMyDetailResponseTwoEmailOneMax),zod.null()]).describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientGetMyDetailResponseTwoPhoneNumberOneMin, max: patientGetMyDetailResponseTwoPhoneNumberOneMax }).refine((v) => patientGetMyDetailResponseTwoPhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoPostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoPostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoPostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseTwoPostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientGetMyDetailResponseTwoPostalAddressPostalCodeOneMax }).refine((v) => patientGetMyDetailResponseTwoPostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()]).and(zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreeNameMax }).describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreeNameKanaMax }).describe('ふりがな'),
  "birthday": zod.string().date().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreeOrganizationNameMax }).describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreeOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientGetMyDetailResponseThreeOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreeEmployeeNumberOneMax }),zod.null()]).describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientGetMyDetailResponseThreeEmailOneMin).max(patientGetMyDetailResponseThreeEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientGetMyDetailResponseThreePhoneNumberOneMin, max: patientGetMyDetailResponseThreePhoneNumberOneMax }).refine((v) => patientGetMyDetailResponseThreePhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientGetMyDetailResponseThreePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientGetMyDetailResponseThreePostalAddressPostalCodeOneMax }).refine((v) => patientGetMyDetailResponseThreePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()).describe('患者の詳細情報')

/**
 * 患者本人が選択した医療機関に対する紹介状依頼を作成します。
 * patientId は認証コンテキストから解決されます。
 * 請求主体となる「元クリニック」は、患者の current_clinic_organization_id をサーバ側で解決して保存します。
 * clinicId は「紹介先クリニック」を表します。
 * @summary 患者本人の紹介状依頼を作成する
 */
export const patientCreateReferralRequestBodyNotesMax = 2000;



export const PatientCreateReferralRequestBody = zod.object({
  "clinicId": zod.string().uuid().describe('紹介先クリニックID（UUID）。請求主体となる元クリニックは患者の current_clinic_organization_id からサーバ側で解決されます。'),
  "notes": zGraphemeString({ min: 1, max: patientCreateReferralRequestBodyNotesMax }).optional().describe('連絡事項')
}).strict().describe('患者紹介状依頼作成リクエスト')

export const PatientCreateReferralRequestResponse = zod.object({
  "referralRequestId": zod.string().uuid().describe('紹介状依頼ID（UUID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "clinicId": zod.string().uuid().describe('依頼先クリニックID（UUID）'),
  "status": zod.enum(['requested', 'mailed']).describe('依頼ステータス'),
  "requestedAt": zod.string().datetime({"offset":true}).describe('依頼日時（RFC3339）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者紹介状依頼')

/**
 * 指定された患者（patientId）の紹介状依頼一覧を返します。
 * 患者詳細画面の紹介状発行状況表示に必要な項目（紹介先名、紹介状ステータス、依頼日時、発行日時）を返却します。
 * 請求済みを含む紹介状依頼を返却します。
 *
 * 可視性ルール:
 * - clinic-* は、自身の医療機関が紹介元（source_clinic_organization_id）である紹介状依頼のみ閲覧可能
 * - 紹介先（clinic_organization_id）のみ一致する紹介状依頼は閲覧不可
 * - ops-* / patient-admin は紹介状依頼を閲覧可能
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の紹介状依頼一覧を取得する
 */
export const PatientListReferralRequestsParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const PatientListReferralRequestsResponse = zod.object({
  "items": zod.array(zod.object({
  "referralRequestId": zod.string().uuid().describe('紹介状依頼ID（UUID）'),
  "referralStatus": zod.enum(['requested', 'mailed']).describe('紹介状ステータス'),
  "requestedAt": zod.string().datetime({"offset":true}).describe('紹介状依頼日時（RFC3339）'),
  "mailedAt": zod.string().datetime({"offset":true}).nullish().describe('紹介状発行日時（status が mailed の場合に利用）'),
  "clinicName": zod.string().describe('紹介先医療機関名')
}).strict().describe('紹介状発行状況表示向け紹介状依頼情報'))
}).strict()

/**
 * 指定患者の紹介状依頼ステータスを更新します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の紹介状依頼ステータスを更新する
 */
export const PatientUpdateReferralRequestParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "referralRequestId": zod.string().uuid().describe('紹介状依頼ID（UUID）')
}).strict()

export const PatientUpdateReferralRequestBody = zod.object({
  "status": zod.enum(['requested', 'mailed']).describe('紹介状依頼ステータス。\n指定可能値:\n- requested\n- mailed\n')
}).strict().describe('患者紹介状依頼更新リクエスト')

export const PatientUpdateReferralRequestResponse = zod.object({
  "referralRequestId": zod.string().uuid().describe('紹介状依頼ID（UUID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "clinicId": zod.string().uuid().describe('依頼先クリニックID（UUID）'),
  "status": zod.enum(['requested', 'mailed']).describe('依頼ステータス'),
  "requestedAt": zod.string().datetime({"offset":true}).describe('依頼日時（RFC3339）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者紹介状依頼')

/**
 * 指定された患者（patientId）の保険証・身分証ダウンロード用の署名付きURLを返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の保険証/身分証の署名付きURLを取得する
 */
export const PatientGetIdentityUrlsParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientGetIdentityUrlsResponseInsuranceCardFrontResourcePathOneRegExp = new RegExp('^/patients/.+');
export const patientGetIdentityUrlsResponseIdentityDocumentFrontResourcePathOneRegExp = new RegExp('^/patients/.+');


export const PatientGetIdentityUrlsResponse = zod.object({
  "insuranceCard": zod.object({
  "frontResourcePath": zod.union([zod.string().refine((v) => patientGetIdentityUrlsResponseInsuranceCardFrontResourcePathOneRegExp.test(v)),zod.null()]).describe('保険証（表面）のメディアリソースパス（例: /patients/{patientId}/...）。未登録の場合はnull。')
}).strict().describe('保険証のメディアリソースパスセット'),
  "identityDocument": zod.object({
  "frontResourcePath": zod.union([zod.string().refine((v) => patientGetIdentityUrlsResponseIdentityDocumentFrontResourcePathOneRegExp.test(v)),zod.null()]).describe('身分証（表面）のメディアリソースパス（例: /patients/{patientId}/...）。未登録の場合はnull。')
}).strict().describe('身分証のメディアリソースパスセット')
}).strict().describe('患者の保険証/身分証ダウンロード用のメディアリソースパスセットをレスポンスします。\nそれぞれのドキュメントは、表面（front）のリソースパスを持つオブジェクト形式です。\nリソースパスは未登録の場合はnullとなります。\n')

/**
 * 患者IDに対応する患者の識別番号（医療機関独自の番号）を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の識別番号（医療機関独自の番号）を取得する
 */
export const PatientGetLocalIdParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientGetLocalIdResponsePatientLocalIdMax = 100;



export const PatientGetLocalIdResponse = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "patientLocalId": zGraphemeString({ min: 1, max: patientGetLocalIdResponsePatientLocalIdMax }).describe('医療機関独自の患者識別番号')
}).strict().describe('患者の識別番号（医療機関独自の番号）')

/**
 * 患者IDに対応する患者の識別番号（医療機関独自の番号）を部分更新します（指定項目のみ更新）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の識別番号（医療機関独自の番号）を更新する
 */
export const PatientUpdateLocalIdParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientUpdateLocalIdBodyPatientLocalIdMax = 100;



export const PatientUpdateLocalIdBody = zod.object({
  "patientLocalId": zGraphemeString({ min: 1, max: patientUpdateLocalIdBodyPatientLocalIdMax }).describe('医療機関独自の患者識別番号')
}).strict().describe('患者の識別番号（医療機関独自の番号）の更新リクエスト')

export const patientUpdateLocalIdResponsePatientLocalIdMax = 100;



export const PatientUpdateLocalIdResponse = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "patientLocalId": zGraphemeString({ min: 1, max: patientUpdateLocalIdResponsePatientLocalIdMax }).describe('医療機関独自の患者識別番号')
}).strict().describe('患者の識別番号（医療機関独自の番号）')

/**
 * 指定された患者（patientId）の診断結果一覧を返します。
 *
 * 各行には consultationType（ONLINE / IN_PERSON）を含みます。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の診断結果一覧を取得する
 */
export const PatientListDiagnosesParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ユーザーID（UUID）')
}).strict()

export const patientListDiagnosesQueryPageDefault = 0;
export const patientListDiagnosesQueryPageMin = 0;

export const patientListDiagnosesQuerySizeDefault = 20;
export const patientListDiagnosesQuerySizeMax = 2000;

export const patientListDiagnosesQuerySortDefault = `createdAt,desc`;

export const PatientListDiagnosesQueryParams = zod.object({
  "page": zod.number().int().min(patientListDiagnosesQueryPageMin).default(patientListDiagnosesQueryPageDefault).describe('取得ページ番号（0開始）'),
  "size": zod.number().int().min(1).max(patientListDiagnosesQuerySizeMax).default(patientListDiagnosesQuerySizeDefault).describe('1ページあたりの件数'),
  "sort": zod.string().default(patientListDiagnosesQuerySortDefault).describe('ソートキー（例: createdAt,desc）')
}).strict()

export const patientListDiagnosesResponseItemsItemMedicalRecordOneMax = 50000;

export const patientListDiagnosesResponseItemsItemDiagnosisResultPdfResourcePathOneMax = 8192;


export const patientListDiagnosesResponseItemsItemDiagnosisResultPdfResourcePathOneRegExp = new RegExp('^/(patients|uploads)/.+');
export const patientListDiagnosesResponseItemsItemClinicOrganizationNameMax = 200;

export const patientListDiagnosesResponseItemsItemDoctorNameMax = 100;

export const patientListDiagnosesResponsePagePageMin = 0;

export const patientListDiagnosesResponsePageSizeMax = 2000;

export const patientListDiagnosesResponsePageTotalElementsMin = 0;

export const patientListDiagnosesResponsePageTotalPagesMin = 0;



export const PatientListDiagnosesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid().describe('診断結果ID（UUID）'),
  "reservationId": zod.string().uuid().describe('予約ID（UUID）'),
  "consultationDatetime": zod.string().datetime({"offset":true}).describe('診療日時（RFC3339）'),
  "clinicalFindings": zod.union([zod.enum(['no_findings', 'observation_required', 'treatment_recommended', 'treatment_required', 'treatment_required_cpap', 'treatment_required_non_cpap', 'pre_treatment_cancelled', 'new', 'prescription_change', 'device_change', 'mask_change', 'completed', 'treatment_started', 'no_change', 'stopped', 'resumed']),zod.null()]).optional().describe('臨床所見（未登録時はnull）'),
  "medicalRecord": zod.union([zGraphemeString({ max: patientListDiagnosesResponseItemsItemMedicalRecordOneMax }),zod.null()]).optional().describe('カルテ（未登録時はnull）'),
  "diagnosisResultPdfResourcePath": zod.union([zGraphemeString({ max: patientListDiagnosesResponseItemsItemDiagnosisResultPdfResourcePathOneMax }).refine((v) => patientListDiagnosesResponseItemsItemDiagnosisResultPdfResourcePathOneRegExp.test(v)),zod.null()]).optional().describe('診断結果PDFのメディアリソースパス（例: /patients/{patientId}/... または /uploads/{organizationId}/...、未登録時はnull）'),
  "clinicOrganizationId": zod.string().uuid().describe('診療を実施した医療機関の組織ID（UUID）'),
  "clinicOrganizationName": zGraphemeString({ min: 1, max: patientListDiagnosesResponseItemsItemClinicOrganizationNameMax }).describe('診療を実施した医療機関名'),
  "doctorUserId": zod.string().uuid().describe('担当医師のユーザーID（UUID）'),
  "doctorName": zGraphemeString({ min: 1, max: patientListDiagnosesResponseItemsItemDoctorNameMax }).describe('担当医師名'),
  "consultationType": zod.enum(['ONLINE', 'IN_PERSON']).describe('診療種別。\n- ONLINE: オンライン診療\n- IN_PERSON: 対面診療\n'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の診断結果（診療記録）')),
  "page": zod.object({
  "page": zod.number().int().min(patientListDiagnosesResponsePagePageMin).describe('現在のページ番号（0開始）'),
  "size": zod.number().int().min(1).max(patientListDiagnosesResponsePageSizeMax).describe('1ページあたりの件数'),
  "totalElements": zod.number().int().min(patientListDiagnosesResponsePageTotalElementsMin).describe('全要素数'),
  "totalPages": zod.number().int().min(patientListDiagnosesResponsePageTotalPagesMin).describe('全ページ数'),
  "hasNext": zod.boolean().describe('次のページがあるか'),
  "hasPrevious": zod.boolean().describe('前のページがあるか')
}).strict().describe('ページングメタ情報')
}).strict()

/**
 * 指定された患者（patientId）に対して診断結果を登録します。
 * `reservationId` は当該患者に紐づく予約であることをサーバー側で検証します。
 * 診療種別はリクエストからは受け取らず、予約の種別を引き継ぎます。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*
 * @summary 患者の診断結果を登録する
 */
export const PatientCreateDiagnosisParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ユーザーID（UUID）')
}).strict()

export const patientCreateDiagnosisBodyMedicalRecordMax = 50000;

export const patientCreateDiagnosisBodyDiagnosisResultPdfS3KeyMax = 2048;

export const patientCreateDiagnosisBodyClinicOrganizationNameMax = 200;

export const patientCreateDiagnosisBodyDoctorNameMax = 100;



export const PatientCreateDiagnosisBody = zod.object({
  "reservationId": zod.string().uuid().describe('予約ID（UUID）。指定患者に紐づくことをサーバーで検証する。'),
  "consultationDatetime": zod.string().datetime({"offset":true}).describe('診療日時（RFC3339）'),
  "clinicalFindings": zod.enum(['no_findings', 'observation_required', 'treatment_recommended', 'treatment_required', 'treatment_required_cpap', 'treatment_required_non_cpap', 'pre_treatment_cancelled', 'new', 'prescription_change', 'device_change', 'mask_change', 'completed', 'treatment_started', 'no_change', 'stopped', 'resumed']).optional().describe('臨床所見'),
  "medicalRecord": zGraphemeString({ min: 1, max: patientCreateDiagnosisBodyMedicalRecordMax }).optional().describe('カルテ'),
  "diagnosisResultPdfS3Key": zGraphemeString({ max: patientCreateDiagnosisBodyDiagnosisResultPdfS3KeyMax }).optional().describe('診断結果PDFの格納先S3キー (S3 object key: 例 patients/{patientId}/diagnoses/{id}/result.pdf)'),
  "clinicOrganizationId": zod.string().uuid().describe('診療を実施した医療機関の組織ID（UUID）'),
  "clinicOrganizationName": zGraphemeString({ min: 1, max: patientCreateDiagnosisBodyClinicOrganizationNameMax }).describe('診療を実施した医療機関名'),
  "doctorUserId": zod.string().uuid().describe('担当医師のユーザーID（UUID）'),
  "doctorName": zGraphemeString({ min: 1, max: patientCreateDiagnosisBodyDoctorNameMax }).describe('担当医師名'),
  "nextConsultationType": zod.enum(['ONLINE', 'IN_PERSON']).optional().describe('次回の診療形式（医師の指定。省略時は指定なし）')
}).strict().describe('患者の診断結果の登録リクエスト')

export const patientCreateDiagnosisResponseMedicalRecordOneMax = 50000;

export const patientCreateDiagnosisResponseDiagnosisResultPdfResourcePathOneMax = 8192;


export const patientCreateDiagnosisResponseDiagnosisResultPdfResourcePathOneRegExp = new RegExp('^/(patients|uploads)/.+');
export const patientCreateDiagnosisResponseClinicOrganizationNameMax = 200;

export const patientCreateDiagnosisResponseDoctorNameMax = 100;



export const PatientCreateDiagnosisResponse = zod.object({
  "id": zod.string().uuid().describe('診断結果ID（UUID）'),
  "reservationId": zod.string().uuid().describe('予約ID（UUID）'),
  "consultationDatetime": zod.string().datetime({"offset":true}).describe('診療日時（RFC3339）'),
  "clinicalFindings": zod.union([zod.enum(['no_findings', 'observation_required', 'treatment_recommended', 'treatment_required', 'treatment_required_cpap', 'treatment_required_non_cpap', 'pre_treatment_cancelled', 'new', 'prescription_change', 'device_change', 'mask_change', 'completed', 'treatment_started', 'no_change', 'stopped', 'resumed']),zod.null()]).optional().describe('臨床所見（未登録時はnull）'),
  "medicalRecord": zod.union([zGraphemeString({ max: patientCreateDiagnosisResponseMedicalRecordOneMax }),zod.null()]).optional().describe('カルテ（未登録時はnull）'),
  "diagnosisResultPdfResourcePath": zod.union([zGraphemeString({ max: patientCreateDiagnosisResponseDiagnosisResultPdfResourcePathOneMax }).refine((v) => patientCreateDiagnosisResponseDiagnosisResultPdfResourcePathOneRegExp.test(v)),zod.null()]).optional().describe('診断結果PDFのメディアリソースパス（例: /patients/{patientId}/... または /uploads/{organizationId}/...、未登録時はnull）'),
  "clinicOrganizationId": zod.string().uuid().describe('診療を実施した医療機関の組織ID（UUID）'),
  "clinicOrganizationName": zGraphemeString({ min: 1, max: patientCreateDiagnosisResponseClinicOrganizationNameMax }).describe('診療を実施した医療機関名'),
  "doctorUserId": zod.string().uuid().describe('担当医師のユーザーID（UUID）'),
  "doctorName": zGraphemeString({ min: 1, max: patientCreateDiagnosisResponseDoctorNameMax }).describe('担当医師名'),
  "consultationType": zod.enum(['ONLINE', 'IN_PERSON']).describe('診療種別。\n- ONLINE: オンライン診療\n- IN_PERSON: 対面診療\n'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の診断結果（診療記録）')

/**
 * 指定された患者（patientId）のパルス検査履歴とPSG検査履歴をまとめて返します。
 * ページングは行わず、該当患者の全件を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者のパルス/PSG検査履歴を取得する
 */
export const PatientGetCheckupHistoryParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ユーザーID（UUID）')
}).strict()

export const patientGetCheckupHistoryResponsePsgHistoryItemClinicNameOneMax = 200;



export const PatientGetCheckupHistoryResponse = zod.object({
  "pulseHistory": zod.array(zod.object({
  "checkupPerformedOn": zod.union([zod.string().date(),zod.null()]).describe('検査実施日（未登録時はnull）'),
  "odi": zod.union([zod.number(),zod.null()]).describe('ODI値（未登録時はnull）')
}).strict().describe('パルス検査履歴の1件')),
  "psgHistory": zod.array(zod.object({
  "checkupPerformedOn": zod.union([zod.string().date(),zod.null()]).describe('検査実施日（未登録時はnull）'),
  "ahi": zod.union([zod.number(),zod.null()]).describe('AHI値（未登録時はnull）'),
  "clinicalFindings": zod.union([zod.enum(['no_findings', 'observation_required', 'treatment_recommended', 'treatment_required', 'treatment_required_cpap', 'treatment_required_non_cpap', 'pre_treatment_cancelled', 'new', 'prescription_change', 'device_change', 'mask_change', 'completed', 'treatment_started', 'no_change', 'stopped', 'resumed']),zod.null()]).describe('検査実施日以降で最も近い診療日の臨床所見（該当する診療がない場合はnull）'),
  "clinicName": zod.union([zGraphemeString({ min: 1, max: patientGetCheckupHistoryResponsePsgHistoryItemClinicNameOneMax }),zod.null()]).describe('検査実施日以降で最も近い診療日の診察を行った医療機関名（該当する診療または医療機関が無い場合はnull）')
}).strict().describe('PSG検査履歴の1件'))
}).strict()

/**
 * 指定された患者（patientId）の診療記録のうち、治療目的（billing_item_type = TREATMENT）の
 * ものだけをまとめて返します。初回スクリーニング/PSG検査に伴う診療記録は含みません。
 * ページングは行わず、該当患者の全件を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の治療目的の受診履歴を取得する
 */
export const PatientGetTreatmentVisitHistoryParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ユーザーID（UUID）')
}).strict()




export const PatientGetTreatmentVisitHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "consultationDatetime": zod.string().datetime({"offset":true}).describe('診療日時'),
  "clinicOrganizationName": zGraphemeString({ min: 1 }).describe('診療を行った医療機関名')
}).strict().describe('治療目的の受診履歴の1件'))
}).strict()

/**
 * 指定された患者（patientId）のPSGステータス（statusPsg）の変更履歴を、変更日時の昇順で返します。
 * ページングは行わず、該当患者の全件を返します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者のPSGステータス変更履歴を取得する
 */
export const PatientGetPsgStatusHistoryParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ユーザーID（UUID）')
}).strict()

export const PatientGetPsgStatusHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "status": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).describe('変更後のPSGステータス'),
  "changedAt": zod.string().datetime({"offset":true}).describe('変更日時')
}).strict().describe('PSGステータス変更履歴の1件'))
}).strict()

/**
 * 指定された患者（patientId）に対して手動登録済みのCPAP治療実績（平均AHI・装着率・
 * 平均使用時間の期間集計値）を、対象期間開始日（periodStart）の降順ですべて返します。
 * ページングは行いません。該当する実績が1件もない場合はitemsが空配列で返ります。
 *
 * RBAC:
 * - 許可: ops-*\/clinic-*\/patient-admin/health-nurse/patient-user
 * - clinic-* の場合、各実績が紐づく通院先クリニック（clinicOrganizationId、登録時点でのその患者の
 *   通院先。登録操作自体はops-admin/ops-operatorのみが行い、クリニックが自ら記録することはない）が
 *   閲覧クリニックと一致する実績のみに絞り込む
 * @summary 患者のCPAP治療実績（期間集計値）履歴を取得する
 */
export const PatientGetCpapTreatmentSummaryHistoryParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ユーザーID（UUID）')
}).strict()

export const PatientGetCpapTreatmentSummaryHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid().optional(),
  "organizationId": zod.string().uuid().optional(),
  "patientId": zod.string().uuid().optional(),
  "clinicOrganizationId": zod.string().uuid().optional(),
  "periodStart": zod.string().datetime({"offset":true}).optional(),
  "periodEnd": zod.string().datetime({"offset":true}).optional(),
  "avgAhi": zod.number().optional(),
  "usageRate": zod.number().nullish(),
  "avgUsageHours": zod.number().optional(),
  "source": zod.enum(['manual']).optional(),
  "createdAt": zod.string().datetime({"offset":true}).optional(),
  "updatedAt": zod.string().datetime({"offset":true}).optional()
}).strict().describe('CPAP治療実績（期間集計値）'))
}).strict()

/**
 * 患者が通院先として選んだ医療機関（クリニック）を更新します。通院先は「clinicId（UUID）」または「clinicName（病院名）」のいずれかで指定できます。指定があれば通院期間（開始日・終了日）も更新します。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の通院先クリニックを更新する
 */
export const PatientUpdateCurrentClinicParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const PatientUpdateCurrentClinicBody = zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().optional().describe('通院先の病院名（IDが不明な場合はこちらを指定）'),
  "startDate": zod.string().date().optional().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).optional().describe('通院終了日（YYYY-MM-DD／未終了はnull）')
}).strict(),zod.object({
  "clinicId": zod.string().uuid().optional().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名（IDが不明な場合はこちらを指定）'),
  "startDate": zod.string().date().optional().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).optional().describe('通院終了日（YYYY-MM-DD／未終了はnull）')
}).strict()]).and(zod.object({
  "clinicId": zod.string().uuid().optional().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().optional().describe('通院先の病院名（IDが不明な場合はこちらを指定）'),
  "startDate": zod.string().date().optional().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).optional().describe('通院終了日（YYYY-MM-DD／未終了はnull）')
}).strict()).describe('患者の通院先クリニックの更新（部分更新）')

export const patientUpdateCurrentClinicResponseOneNameMax = 100;

export const patientUpdateCurrentClinicResponseOneNameKanaMax = 200;

export const patientUpdateCurrentClinicResponseOneOrganizationNameMax = 200;

export const patientUpdateCurrentClinicResponseOneOrganizationHierarchyItemNameMax = 200;

export const patientUpdateCurrentClinicResponseOneOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateCurrentClinicResponseOneEmployeeNumberOneMax = 50;

export const patientUpdateCurrentClinicResponseOneEmailOneMin = 5;
export const patientUpdateCurrentClinicResponseOneEmailOneMax = 254;

export const patientUpdateCurrentClinicResponseOnePhoneNumberOneMin = 10;
export const patientUpdateCurrentClinicResponseOnePhoneNumberOneMax = 20;


export const patientUpdateCurrentClinicResponseOnePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateCurrentClinicResponseOnePostalAddressPrefectureOneMax = 50;

export const patientUpdateCurrentClinicResponseOnePostalAddressMunicipalityOneMax = 100;

export const patientUpdateCurrentClinicResponseOnePostalAddressStreetAddressOneMax = 300;

export const patientUpdateCurrentClinicResponseOnePostalAddressBuildingOneMax = 200;

export const patientUpdateCurrentClinicResponseOnePostalAddressPostalCodeOneMax = 8;


export const patientUpdateCurrentClinicResponseOnePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientUpdateCurrentClinicResponseTwoNameMax = 100;

export const patientUpdateCurrentClinicResponseTwoNameKanaMax = 200;

export const patientUpdateCurrentClinicResponseTwoOrganizationNameMax = 200;

export const patientUpdateCurrentClinicResponseTwoOrganizationHierarchyItemNameMax = 200;

export const patientUpdateCurrentClinicResponseTwoOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateCurrentClinicResponseTwoEmployeeNumberOneMax = 50;

export const patientUpdateCurrentClinicResponseTwoEmailOneMin = 5;
export const patientUpdateCurrentClinicResponseTwoEmailOneMax = 254;

export const patientUpdateCurrentClinicResponseTwoPhoneNumberOneMin = 10;
export const patientUpdateCurrentClinicResponseTwoPhoneNumberOneMax = 20;


export const patientUpdateCurrentClinicResponseTwoPhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateCurrentClinicResponseTwoPostalAddressPrefectureOneMax = 50;

export const patientUpdateCurrentClinicResponseTwoPostalAddressMunicipalityOneMax = 100;

export const patientUpdateCurrentClinicResponseTwoPostalAddressStreetAddressOneMax = 300;

export const patientUpdateCurrentClinicResponseTwoPostalAddressBuildingOneMax = 200;

export const patientUpdateCurrentClinicResponseTwoPostalAddressPostalCodeOneMax = 8;


export const patientUpdateCurrentClinicResponseTwoPostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientUpdateCurrentClinicResponseThreeNameMax = 100;

export const patientUpdateCurrentClinicResponseThreeNameKanaMax = 200;

export const patientUpdateCurrentClinicResponseThreeOrganizationNameMax = 200;

export const patientUpdateCurrentClinicResponseThreeOrganizationHierarchyItemNameMax = 200;

export const patientUpdateCurrentClinicResponseThreeOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateCurrentClinicResponseThreeEmployeeNumberOneMax = 50;

export const patientUpdateCurrentClinicResponseThreeEmailOneMin = 5;
export const patientUpdateCurrentClinicResponseThreeEmailOneMax = 254;

export const patientUpdateCurrentClinicResponseThreePhoneNumberOneMin = 10;
export const patientUpdateCurrentClinicResponseThreePhoneNumberOneMax = 20;


export const patientUpdateCurrentClinicResponseThreePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateCurrentClinicResponseThreePostalAddressPrefectureOneMax = 50;

export const patientUpdateCurrentClinicResponseThreePostalAddressMunicipalityOneMax = 100;

export const patientUpdateCurrentClinicResponseThreePostalAddressStreetAddressOneMax = 300;

export const patientUpdateCurrentClinicResponseThreePostalAddressBuildingOneMax = 200;

export const patientUpdateCurrentClinicResponseThreePostalAddressPostalCodeOneMax = 8;


export const patientUpdateCurrentClinicResponseThreePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');


export const PatientUpdateCurrentClinicResponse = zod.union([zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOneNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOneNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOneOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOneOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateCurrentClinicResponseOneOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOneEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateCurrentClinicResponseOneEmailOneMin).max(patientUpdateCurrentClinicResponseOneEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateCurrentClinicResponseOnePhoneNumberOneMin, max: patientUpdateCurrentClinicResponseOnePhoneNumberOneMax }).refine((v) => patientUpdateCurrentClinicResponseOnePhoneNumberOneRegExp.test(v)),zod.null()]).describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOnePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOnePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOnePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseOnePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateCurrentClinicResponseOnePostalAddressPostalCodeOneMax }).refine((v) => patientUpdateCurrentClinicResponseOnePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict(),zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateCurrentClinicResponseTwoOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateCurrentClinicResponseTwoEmailOneMin).max(patientUpdateCurrentClinicResponseTwoEmailOneMax),zod.null()]).describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateCurrentClinicResponseTwoPhoneNumberOneMin, max: patientUpdateCurrentClinicResponseTwoPhoneNumberOneMax }).refine((v) => patientUpdateCurrentClinicResponseTwoPhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoPostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoPostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoPostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseTwoPostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateCurrentClinicResponseTwoPostalAddressPostalCodeOneMax }).refine((v) => patientUpdateCurrentClinicResponseTwoPostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()]).and(zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreeNameMax }).describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreeNameKanaMax }).describe('ふりがな'),
  "birthday": zod.string().date().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreeOrganizationNameMax }).describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreeOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateCurrentClinicResponseThreeOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreeEmployeeNumberOneMax }),zod.null()]).describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateCurrentClinicResponseThreeEmailOneMin).max(patientUpdateCurrentClinicResponseThreeEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateCurrentClinicResponseThreePhoneNumberOneMin, max: patientUpdateCurrentClinicResponseThreePhoneNumberOneMax }).refine((v) => patientUpdateCurrentClinicResponseThreePhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateCurrentClinicResponseThreePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateCurrentClinicResponseThreePostalAddressPostalCodeOneMax }).refine((v) => patientUpdateCurrentClinicResponseThreePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()).describe('患者の詳細情報')

/**
 * 患者のパルス/PG/PSG/CPAPの各ステータスを1つのエンドポイントで部分更新します（指定項目のみ更新）。
 *
 * RBAC（Option A）:
 * - 許可: ops-*\/clinic-*\/patient-admin
 * - 許可: patient-user（本人のみ。本人判定はサービス層で強制）
 * @summary 患者の治療・検査ステータスを更新する
 */
export const PatientUpdateStatusesParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const PatientUpdateStatusesBody = zod.object({
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス。指定時のみ更新します。'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス。指定時のみ更新します。'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス。指定時のみ更新します。'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス。指定時のみ更新します。')
}).strict().describe('患者の治療・検査ステータスの更新（部分更新）')

export const patientUpdateStatusesResponseOneNameMax = 100;

export const patientUpdateStatusesResponseOneNameKanaMax = 200;

export const patientUpdateStatusesResponseOneOrganizationNameMax = 200;

export const patientUpdateStatusesResponseOneOrganizationHierarchyItemNameMax = 200;

export const patientUpdateStatusesResponseOneOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateStatusesResponseOneEmployeeNumberOneMax = 50;

export const patientUpdateStatusesResponseOneEmailOneMin = 5;
export const patientUpdateStatusesResponseOneEmailOneMax = 254;

export const patientUpdateStatusesResponseOnePhoneNumberOneMin = 10;
export const patientUpdateStatusesResponseOnePhoneNumberOneMax = 20;


export const patientUpdateStatusesResponseOnePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateStatusesResponseOnePostalAddressPrefectureOneMax = 50;

export const patientUpdateStatusesResponseOnePostalAddressMunicipalityOneMax = 100;

export const patientUpdateStatusesResponseOnePostalAddressStreetAddressOneMax = 300;

export const patientUpdateStatusesResponseOnePostalAddressBuildingOneMax = 200;

export const patientUpdateStatusesResponseOnePostalAddressPostalCodeOneMax = 8;


export const patientUpdateStatusesResponseOnePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientUpdateStatusesResponseTwoNameMax = 100;

export const patientUpdateStatusesResponseTwoNameKanaMax = 200;

export const patientUpdateStatusesResponseTwoOrganizationNameMax = 200;

export const patientUpdateStatusesResponseTwoOrganizationHierarchyItemNameMax = 200;

export const patientUpdateStatusesResponseTwoOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateStatusesResponseTwoEmployeeNumberOneMax = 50;

export const patientUpdateStatusesResponseTwoEmailOneMin = 5;
export const patientUpdateStatusesResponseTwoEmailOneMax = 254;

export const patientUpdateStatusesResponseTwoPhoneNumberOneMin = 10;
export const patientUpdateStatusesResponseTwoPhoneNumberOneMax = 20;


export const patientUpdateStatusesResponseTwoPhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateStatusesResponseTwoPostalAddressPrefectureOneMax = 50;

export const patientUpdateStatusesResponseTwoPostalAddressMunicipalityOneMax = 100;

export const patientUpdateStatusesResponseTwoPostalAddressStreetAddressOneMax = 300;

export const patientUpdateStatusesResponseTwoPostalAddressBuildingOneMax = 200;

export const patientUpdateStatusesResponseTwoPostalAddressPostalCodeOneMax = 8;


export const patientUpdateStatusesResponseTwoPostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');
export const patientUpdateStatusesResponseThreeNameMax = 100;

export const patientUpdateStatusesResponseThreeNameKanaMax = 200;

export const patientUpdateStatusesResponseThreeOrganizationNameMax = 200;

export const patientUpdateStatusesResponseThreeOrganizationHierarchyItemNameMax = 200;

export const patientUpdateStatusesResponseThreeOrganizationHierarchyItemDepthMin = 0;


export const patientUpdateStatusesResponseThreeEmployeeNumberOneMax = 50;

export const patientUpdateStatusesResponseThreeEmailOneMin = 5;
export const patientUpdateStatusesResponseThreeEmailOneMax = 254;

export const patientUpdateStatusesResponseThreePhoneNumberOneMin = 10;
export const patientUpdateStatusesResponseThreePhoneNumberOneMax = 20;


export const patientUpdateStatusesResponseThreePhoneNumberOneRegExp = new RegExp('^[0-9]+$');
export const patientUpdateStatusesResponseThreePostalAddressPrefectureOneMax = 50;

export const patientUpdateStatusesResponseThreePostalAddressMunicipalityOneMax = 100;

export const patientUpdateStatusesResponseThreePostalAddressStreetAddressOneMax = 300;

export const patientUpdateStatusesResponseThreePostalAddressBuildingOneMax = 200;

export const patientUpdateStatusesResponseThreePostalAddressPostalCodeOneMax = 8;


export const patientUpdateStatusesResponseThreePostalAddressPostalCodeOneRegExp = new RegExp('^\\d{3}-?\\d{4}$');


export const PatientUpdateStatusesResponse = zod.union([zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOneNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOneNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOneOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOneOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateStatusesResponseOneOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOneEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateStatusesResponseOneEmailOneMin).max(patientUpdateStatusesResponseOneEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateStatusesResponseOnePhoneNumberOneMin, max: patientUpdateStatusesResponseOnePhoneNumberOneMax }).refine((v) => patientUpdateStatusesResponseOnePhoneNumberOneRegExp.test(v)),zod.null()]).describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOnePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOnePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOnePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseOnePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateStatusesResponseOnePostalAddressPostalCodeOneMax }).refine((v) => patientUpdateStatusesResponseOnePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict(),zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoNameMax }).optional().describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoNameKanaMax }).optional().describe('ふりがな'),
  "birthday": zod.string().date().optional().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().optional().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoOrganizationNameMax }).optional().describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateStatusesResponseTwoOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).optional().describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).optional().describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoEmployeeNumberOneMax }),zod.null()]).optional().describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateStatusesResponseTwoEmailOneMin).max(patientUpdateStatusesResponseTwoEmailOneMax),zod.null()]).describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateStatusesResponseTwoPhoneNumberOneMin, max: patientUpdateStatusesResponseTwoPhoneNumberOneMax }).refine((v) => patientUpdateStatusesResponseTwoPhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoPostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoPostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoPostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseTwoPostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateStatusesResponseTwoPostalAddressPostalCodeOneMax }).refine((v) => patientUpdateStatusesResponseTwoPostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().optional().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).optional().describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).optional().describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).optional().describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()]).and(zod.object({
  "userId": zod.string().uuid().optional().describe('ユーザーID（UUID; 認証コンテキストに紐づく本人のユーザーID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreeNameMax }).describe('氏名'),
  "nameKana": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreeNameKanaMax }).describe('ふりがな'),
  "birthday": zod.string().date().describe('生年月日（YYYY-MM-DD; RFC3339 full-date）'),
  "organizationId": zod.string().uuid().describe('所属企業ID（UUID）'),
  "organizationName": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreeOrganizationNameMax }).describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreeOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(patientUpdateStatusesResponseThreeOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).describe('患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が患者の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "gender": zod.union([zod.enum(['男性', '女性']),zod.null()]).describe('性別（未回答の場合はnull）'),
  "employeeNumber": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreeEmployeeNumberOneMax }),zod.null()]).describe('従業員番号（企業が付与する識別子。未設定の場合はnull）'),
  "email": zod.union([zod.string().email().min(patientUpdateStatusesResponseThreeEmailOneMin).max(patientUpdateStatusesResponseThreeEmailOneMax),zod.null()]).optional().describe('連絡用メールアドレス'),
  "phoneNumber": zod.union([zGraphemeString({ min: patientUpdateStatusesResponseThreePhoneNumberOneMin, max: patientUpdateStatusesResponseThreePhoneNumberOneMax }).refine((v) => patientUpdateStatusesResponseThreePhoneNumberOneRegExp.test(v)),zod.null()]).optional().describe('連絡用電話番号'),
  "postalAddress": zod.object({
  "prefecture": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreePostalAddressPrefectureOneMax }),zod.null()]).optional().describe('都道府県（自由入力）。未登録の場合はnull。'),
  "municipality": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreePostalAddressMunicipalityOneMax }),zod.null()]).optional().describe('市区町村（郡・町・村等を含む、自由入力）。未登録の場合はnull。'),
  "streetAddress": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreePostalAddressStreetAddressOneMax }),zod.null()]).optional().describe('丁目・番地・号、字/小字、地番等の自由入力。未登録の場合はnull。'),
  "building": zod.union([zGraphemeString({ min: 1, max: patientUpdateStatusesResponseThreePostalAddressBuildingOneMax }),zod.null()]).optional().describe('建物名・階・号室等（任意）。未登録の場合はnull。'),
  "postalCode": zod.union([zGraphemeString({ max: patientUpdateStatusesResponseThreePostalAddressPostalCodeOneMax }).refine((v) => patientUpdateStatusesResponseThreePostalAddressPostalCodeOneRegExp.test(v)),zod.null()]).optional().describe('郵便番号（ハイフンあり/なし両対応）。未登録の場合はnull。')
}).strict().describe('郵送先住所（日本向けフリーテキストの分割フィールド）。\n\n**読み取り専用（非永続）:**\nこのオブジェクトは個別のDBカラム（address_prefecture, address_municipality, address_street, address_building, postal_code）から\nビュー層で組み立てられます。DBにNULLが保存されている場合、nullがそのまま返されます。\n更新には `PatientProfileUpdateRequest` の `postalAddress` を使用してください。\n'),
  "statusPulse": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('パルス検査のステータス'),
  "statusPg": zod.enum(['オーダーなし', '検査器発送手配待ち', '検査器発送待ち', '検査器発送済・検査実施中', '検査器受領・データ解析中', '検査完了（レポート閲覧可）', '返却予定日超過', 'データ不良・再検査要', '検査完了（データ不良）', '検査完了（キャンセル）']).describe('PG検査のステータス'),
  "statusPsg": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約済（問診記入待ち）', '診療1回目予約中', '診療1回目受診完了', '診療1回目診療費入金待ち', '請求済み', '発送依頼済み', 'データ不良・再検査要', '診療2回目予約依頼', '診療2回目予約中', '診療2回目受診完了', '診療2回目診療費入金待ち', '検査完了（診断確定）', '紹介状必要情報確認中', '紹介状作成依頼', '紹介状作成料入金待ち', '検査完了（紹介状あり）', '検査完了（キャンセル）']).describe('PSG検査のステータス'),
  "statusCpap": zod.enum(['オーダーなし', '診療1回目予約依頼', '診療1回目予約中', '処方指示・同意書起票中', '処方指示・同意書同意依頼', '診療予約依頼', '診療予約中', '受診完了', '診療費入金待ち', '治療終了', '治療開始前キャンセル', '提携外医療機関に通院中', '紹介状必要情報確認中', '処方指示・同意書/紹介状作成依頼', '紹介状作成料入金待ち']).describe('CPAP治療のステータス'),
  "cpapOnlineReservationAllowed": zod.union([zod.boolean(),zod.null()]).optional().describe('CPAP 診療予約依頼ステータスでオンライン予約を許可できる場合は true'),
  "cpapOnlineBlockReason": zod.union([zod.enum(['COMPANY_BILLING', 'IN_PERSON_REQUIRED', 'DOCTOR_DESIGNATED_IN_PERSON']),zod.null()]).optional().describe('CPAP のオンライン予約が禁止される理由'),
  "nextConsultationType": zod.union([zod.enum(['ONLINE', 'IN_PERSON']),zod.null()]).optional().describe('医師が指定した次回の診療形式（最新のCPAP診察での選択。指定なしは null）'),
  "nextConsultationTypeSelectable": zod.boolean().optional().describe('診察結果登録で次回の診療形式を選択できる状態かどうか'),
  "currentClinic": zod.union([zod.object({
  "clinicId": zod.string().uuid().describe('通院先の病院ID（UUID）'),
  "clinicName": zod.string().describe('通院先の病院名'),
  "clinicNameKana": zod.string().describe('通院先の病院名（ふりがな）'),
  "startDate": zod.string().date().describe('通院開始日（YYYY-MM-DD）'),
  "endDate": zod.union([zod.string().date(),zod.null()]).describe('通院終了日（YYYY-MM-DD／未終了はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者の通院先クリニック情報（患者×クリニックの関係）'),zod.null()]).optional().describe('CPAP治療の通院先（クリニック）'),
  "paymentDefaultChannel": zod.union([zod.literal('CARD'),zod.literal('CVS'),zod.literal(null)]).nullish().describe('支払い既定チャネル'),
  "paymentHasActiveCard": zod.boolean().nullish().describe('有効カード有無')
}).strict()).describe('患者の詳細情報')

/**
 * 指定された患者（patientId）に紐づく検査結果レポートのS3キーを登録します。
 * あわせて検査実施日および検査値（AHI/ODI）を同梱して登録できます。
 * 後続のダウンロード用URL発行に利用されます。
 *
 * RBAC（例）:
 * - 許可: ops-*
 * @summary 検査結果レポートアップロード情報を登録する
 */
export const PatientTestReportUploadParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const PatientTestReportUploadBody = zod.object({
  "checkUpCategory": zod.enum(['PULSE', 'PG', 'PSG']).describe('検査カテゴリ'),
  "checkUpReportS3Key": zod.string().describe('検査結果レポートファイルのS3オブジェクトキー'),
  "checkupPerformedOn": zod.string().date().nullish().describe('検査実施日（未設定時はnull）'),
  "ahi": zod.number().nullish().describe('AHI（未設定時はnull）'),
  "odi": zod.number().nullish().describe('ODI（未設定時はnull）')
}).strict().describe('患者の検査結果レポートを登録したことを報告するAPI')

export const PatientTestReportUploadResponse = zod.void()

/**
 * 指定された患者（patientId）に紐づく検査結果レポートのダウンロード情報を items 配列で返します。
 * 各要素は検査カテゴリ・署名付きURL・作成日時に加え、検査実施日および検査値（AHI/ODI）を返します。
 *
 * RBAC（例）:
 * - 許可: ops-*\/clinic-*
 * @summary 検査結果レポートのダウンロードURL一覧を取得する
 */
export const PatientGetTestReportDownloadUrlParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const patientGetTestReportDownloadUrlResponseItemsItemCheckUpReportResourcePathRegExp = new RegExp('^/(patients|uploads)/.+');


export const PatientGetTestReportDownloadUrlResponse = zod.object({
  "items": zod.array(zod.object({
  "checkUpCategory": zod.enum(['PULSE', 'PG', 'PSG']).describe('検査カテゴリ'),
  "checkUpReportResourcePath": zod.string().refine((v) => patientGetTestReportDownloadUrlResponseItemsItemCheckUpReportResourcePathRegExp.test(v)).nullish().describe('メディアリソースパス（未登録時はnull）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('レポートの作成日時（ISO 8601）'),
  "checkupPerformedOn": zod.string().date().nullish().describe('検査実施日（未設定時はnull）'),
  "ahi": zod.number().nullish().describe('AHI（未設定時はnull）'),
  "odi": zod.number().nullish().describe('ODI（未設定時はnull）')
}).strict()).describe('ダウンロード対象のレポート一覧')
}).strict().describe('検査結果レポートのダウンロード項目一覧')

/**
 * 指定された患者（patientId）に紐づく保険証/身分証のS3キーを登録します（PATCHセマンティクス）。
 * 以後のダウンロード用URL発行に利用されます。
 * オブジェクト形式で保険証・身分証それぞれの表面(front)のS3キーをまとめて渡せます。
 * - フィールド未指定の場合は変更を行いません（既存データは保持）。
 * - プロパティ（insuranceCard/identityDocument）自体を未指定の場合は当該カテゴリの変更は行いません。
 * - 削除は専用の DELETE エンドポイント（PatientIdentityDocumentCategoryDelete）を使用してください。
 * /uploads/initと/uploads/completeを事前に実行済みなことが前提です。
 *
 * RBAC（例）:
 * - 許可: ops-*
 * - 許可: patient-user（本人のみ。patientIdの指定内容に関わらず、本人に対して更新が行われます）
 * @summary 保険証/身分証のアップロード情報を登録する
 */
export const PatientIdentityUploadCompleteParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）')
}).strict()

export const PatientIdentityUploadCompleteBody = zod.object({
  "insuranceCard": zod.object({
  "frontS3Key": zod.string().nullish().describe('表面のS3オブジェクトキー。指定した場合は表面を登録/更新します。未指定またはnullの場合は変更なし。')
}).strict().optional().describe('保険証/身分証の表面のS3キーを指定する入力（PATCHセマンティクス）。\nフィールド未指定の場合は変更しません。\n削除は専用の DELETE エンドポイント（PatientIdentityDocumentCategoryDelete）を使用してください。\n'),
  "identityDocument": zod.object({
  "frontS3Key": zod.string().nullish().describe('表面のS3オブジェクトキー。指定した場合は表面を登録/更新します。未指定またはnullの場合は変更なし。')
}).strict().optional().describe('保険証/身分証の表面のS3キーを指定する入力（PATCHセマンティクス）。\nフィールド未指定の場合は変更しません。\n削除は専用の DELETE エンドポイント（PatientIdentityDocumentCategoryDelete）を使用してください。\n')
}).strict().describe('患者の保険証/身分証の登録完了をまとめて通知する入力（PATCHセマンティクス）。\nオブジェクト形式で表面(front)のS3キーを渡します。\n- フィールドを未指定の場合は変更しません（既存データは保持）。\n- プロパティ自体を未指定の場合は当該カテゴリの変更を行いません。例えば、保険証のみ更新したい場合は`insuranceCard`のみ指定し、`identityDocument`はリクエストから省略します。\n- 削除は専用の DELETE エンドポイント（PatientIdentityDocumentCategoryDelete）を使用してください。\n')

export const PatientIdentityUploadCompleteResponse = zod.void()

/**
 * 指定した患者の保険証または身分証をカテゴリ単位で削除（論理削除）します。
 * カテゴリ配下のアクティブな書類行（FRONT/BACK）はすべて削除対象です。
 *
 * RBAC（例）:
 * - 許可: ops-*
 * - 許可: patient-user（本人のみ。patientIdの指定内容に関わらず、本人に対して削除が行われます）
 * @summary 保険証/身分証をカテゴリ単位で削除する
 */
export const PatientIdentityDocumentCategoryDeleteParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "category": zod.enum(['INSURANCE_CARD', 'IDENTITY_DOCUMENT']).describe('書類の種別（INSURANCE_CARD または IDENTITY_DOCUMENT）')
}).strict()

export const PatientIdentityDocumentCategoryDeleteResponse = zod.void()

/**
 * 患者が通える診療所がみつからない場合に、理由を添えてopsへリクエストを送信します。
 * status=waiting_proposal の提案レコードが作成され、opsにタスクが発行されます。
 * @summary 「診療所がみつからない」リクエストを送信する
 */
export const PatientCreateClinicProposalBody = zod.object({
  "reasonCode": zod.enum(['cannot_find_commutable', 'no_nearby_clinic', 'no_preferred_clinic']).describe('診療所が見つからない理由')
}).strict().describe('患者からの「診療所がみつからない」リクエスト作成')

export const patientCreateClinicProposalResponseClinicNameMax = 200;

export const patientCreateClinicProposalResponseClinicDepartmentMax = 200;

export const patientCreateClinicProposalResponseClinicDescriptionMax = 4000;

export const patientCreateClinicProposalResponseClinicAddressMax = 500;

export const patientCreateClinicProposalResponseClinicClosedDaysMax = 200;

export const patientCreateClinicProposalResponseClinicOpeningHoursMondayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursMondayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursMondayDefault = [];
export const patientCreateClinicProposalResponseClinicOpeningHoursTuesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursTuesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursTuesdayDefault = [];
export const patientCreateClinicProposalResponseClinicOpeningHoursWednesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursWednesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursWednesdayDefault = [];
export const patientCreateClinicProposalResponseClinicOpeningHoursThursdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursThursdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursThursdayDefault = [];
export const patientCreateClinicProposalResponseClinicOpeningHoursFridayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursFridayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursFridayDefault = [];
export const patientCreateClinicProposalResponseClinicOpeningHoursSaturdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursSaturdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursSaturdayDefault = [];
export const patientCreateClinicProposalResponseClinicOpeningHoursSundayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursSundayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientCreateClinicProposalResponseClinicOpeningHoursSundayDefault = [];

export const PatientCreateClinicProposalResponse = zod.object({
  "proposalId": zod.string().uuid().describe('提案ID'),
  "reasonCode": zod.enum(['cannot_find_commutable', 'no_nearby_clinic', 'no_preferred_clinic']).describe('患者が選択した理由'),
  "message": zod.string().optional().describe('オペレーターから患者へのメッセージ'),
  "clinic": zod.object({
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "name": zGraphemeString({ max: patientCreateClinicProposalResponseClinicNameMax }).describe('医療機関名'),
  "department": zGraphemeString({ max: patientCreateClinicProposalResponseClinicDepartmentMax }).describe('診療科目'),
  "description": zGraphemeString({ max: patientCreateClinicProposalResponseClinicDescriptionMax }).describe('医療機関説明'),
  "address": zGraphemeString({ max: patientCreateClinicProposalResponseClinicAddressMax }).describe('住所'),
  "closedDays": zGraphemeString({ max: patientCreateClinicProposalResponseClinicClosedDaysMax }).describe('休診日'),
  "openingHours": zod.object({
  "monday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursMondayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursMondayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientCreateClinicProposalResponseClinicOpeningHoursMondayDefault),
  "tuesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursTuesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursTuesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientCreateClinicProposalResponseClinicOpeningHoursTuesdayDefault),
  "wednesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursWednesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursWednesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientCreateClinicProposalResponseClinicOpeningHoursWednesdayDefault),
  "thursday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursThursdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursThursdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientCreateClinicProposalResponseClinicOpeningHoursThursdayDefault),
  "friday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursFridayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursFridayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientCreateClinicProposalResponseClinicOpeningHoursFridayDefault),
  "saturday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursSaturdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursSaturdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientCreateClinicProposalResponseClinicOpeningHoursSaturdayDefault),
  "sunday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursSundayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientCreateClinicProposalResponseClinicOpeningHoursSundayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientCreateClinicProposalResponseClinicOpeningHoursSundayDefault)
}).strict().describe('曜日別の診療時間設定。各曜日は時間帯スロットの配列（空配列は休診）。')
}).strict().optional().describe('管理外クリニックの詳細情報'),
  "status": zod.enum(['waiting_proposal', 'pending', 'accepted', 'rejected']).describe('提案ステータス'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時')
}).strict().describe('患者向け医療機関提案レスポンス')

/**
 * 患者の最新のpending状態の医療機関提案を取得します。
 * タスクから提案画面に遷移する際にproposalIdを事前に知らなくても利用できます。
 * @summary 最新のpending提案を取得する
 */
export const patientGetLatestPendingClinicProposalResponseClinicNameMax = 200;

export const patientGetLatestPendingClinicProposalResponseClinicDepartmentMax = 200;

export const patientGetLatestPendingClinicProposalResponseClinicDescriptionMax = 4000;

export const patientGetLatestPendingClinicProposalResponseClinicAddressMax = 500;

export const patientGetLatestPendingClinicProposalResponseClinicClosedDaysMax = 200;

export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursMondayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursMondayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursMondayDefault = [];
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursTuesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursTuesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursTuesdayDefault = [];
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursWednesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursWednesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursWednesdayDefault = [];
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursThursdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursThursdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursThursdayDefault = [];
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursFridayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursFridayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursFridayDefault = [];
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSaturdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSaturdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSaturdayDefault = [];
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSundayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSundayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSundayDefault = [];

export const PatientGetLatestPendingClinicProposalResponse = zod.object({
  "proposalId": zod.string().uuid().describe('提案ID'),
  "reasonCode": zod.enum(['cannot_find_commutable', 'no_nearby_clinic', 'no_preferred_clinic']).describe('患者が選択した理由'),
  "message": zod.string().optional().describe('オペレーターから患者へのメッセージ'),
  "clinic": zod.object({
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "name": zGraphemeString({ max: patientGetLatestPendingClinicProposalResponseClinicNameMax }).describe('医療機関名'),
  "department": zGraphemeString({ max: patientGetLatestPendingClinicProposalResponseClinicDepartmentMax }).describe('診療科目'),
  "description": zGraphemeString({ max: patientGetLatestPendingClinicProposalResponseClinicDescriptionMax }).describe('医療機関説明'),
  "address": zGraphemeString({ max: patientGetLatestPendingClinicProposalResponseClinicAddressMax }).describe('住所'),
  "closedDays": zGraphemeString({ max: patientGetLatestPendingClinicProposalResponseClinicClosedDaysMax }).describe('休診日'),
  "openingHours": zod.object({
  "monday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursMondayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursMondayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetLatestPendingClinicProposalResponseClinicOpeningHoursMondayDefault),
  "tuesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursTuesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursTuesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetLatestPendingClinicProposalResponseClinicOpeningHoursTuesdayDefault),
  "wednesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursWednesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursWednesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetLatestPendingClinicProposalResponseClinicOpeningHoursWednesdayDefault),
  "thursday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursThursdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursThursdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetLatestPendingClinicProposalResponseClinicOpeningHoursThursdayDefault),
  "friday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursFridayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursFridayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetLatestPendingClinicProposalResponseClinicOpeningHoursFridayDefault),
  "saturday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSaturdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSaturdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSaturdayDefault),
  "sunday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSundayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSundayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetLatestPendingClinicProposalResponseClinicOpeningHoursSundayDefault)
}).strict().describe('曜日別の診療時間設定。各曜日は時間帯スロットの配列（空配列は休診）。')
}).strict().optional().describe('管理外クリニックの詳細情報'),
  "status": zod.enum(['waiting_proposal', 'pending', 'accepted', 'rejected']).describe('提案ステータス'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時')
}).strict().describe('患者向け医療機関提案レスポンス')

/**
 * 指定されたproposalIdの医療機関提案詳細を取得します。
 * 患者本人かつ自身宛ての提案のみ取得可能です。
 * @summary 提案詳細を取得する
 */
export const PatientGetClinicProposalDetailParams = zod.object({
  "proposalId": zod.string().uuid().describe('提案ID')
}).strict()

export const patientGetClinicProposalDetailResponseClinicNameMax = 200;

export const patientGetClinicProposalDetailResponseClinicDepartmentMax = 200;

export const patientGetClinicProposalDetailResponseClinicDescriptionMax = 4000;

export const patientGetClinicProposalDetailResponseClinicAddressMax = 500;

export const patientGetClinicProposalDetailResponseClinicClosedDaysMax = 200;

export const patientGetClinicProposalDetailResponseClinicOpeningHoursMondayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursMondayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursMondayDefault = [];
export const patientGetClinicProposalDetailResponseClinicOpeningHoursTuesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursTuesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursTuesdayDefault = [];
export const patientGetClinicProposalDetailResponseClinicOpeningHoursWednesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursWednesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursWednesdayDefault = [];
export const patientGetClinicProposalDetailResponseClinicOpeningHoursThursdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursThursdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursThursdayDefault = [];
export const patientGetClinicProposalDetailResponseClinicOpeningHoursFridayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursFridayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursFridayDefault = [];
export const patientGetClinicProposalDetailResponseClinicOpeningHoursSaturdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursSaturdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursSaturdayDefault = [];
export const patientGetClinicProposalDetailResponseClinicOpeningHoursSundayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursSundayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientGetClinicProposalDetailResponseClinicOpeningHoursSundayDefault = [];

export const PatientGetClinicProposalDetailResponse = zod.object({
  "proposalId": zod.string().uuid().describe('提案ID'),
  "reasonCode": zod.enum(['cannot_find_commutable', 'no_nearby_clinic', 'no_preferred_clinic']).describe('患者が選択した理由'),
  "message": zod.string().optional().describe('オペレーターから患者へのメッセージ'),
  "clinic": zod.object({
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "name": zGraphemeString({ max: patientGetClinicProposalDetailResponseClinicNameMax }).describe('医療機関名'),
  "department": zGraphemeString({ max: patientGetClinicProposalDetailResponseClinicDepartmentMax }).describe('診療科目'),
  "description": zGraphemeString({ max: patientGetClinicProposalDetailResponseClinicDescriptionMax }).describe('医療機関説明'),
  "address": zGraphemeString({ max: patientGetClinicProposalDetailResponseClinicAddressMax }).describe('住所'),
  "closedDays": zGraphemeString({ max: patientGetClinicProposalDetailResponseClinicClosedDaysMax }).describe('休診日'),
  "openingHours": zod.object({
  "monday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursMondayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursMondayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetClinicProposalDetailResponseClinicOpeningHoursMondayDefault),
  "tuesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursTuesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursTuesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetClinicProposalDetailResponseClinicOpeningHoursTuesdayDefault),
  "wednesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursWednesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursWednesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetClinicProposalDetailResponseClinicOpeningHoursWednesdayDefault),
  "thursday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursThursdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursThursdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetClinicProposalDetailResponseClinicOpeningHoursThursdayDefault),
  "friday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursFridayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursFridayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetClinicProposalDetailResponseClinicOpeningHoursFridayDefault),
  "saturday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursSaturdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursSaturdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetClinicProposalDetailResponseClinicOpeningHoursSaturdayDefault),
  "sunday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursSundayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientGetClinicProposalDetailResponseClinicOpeningHoursSundayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientGetClinicProposalDetailResponseClinicOpeningHoursSundayDefault)
}).strict().describe('曜日別の診療時間設定。各曜日は時間帯スロットの配列（空配列は休診）。')
}).strict().optional().describe('管理外クリニックの詳細情報'),
  "status": zod.enum(['waiting_proposal', 'pending', 'accepted', 'rejected']).describe('提案ステータス'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時')
}).strict().describe('患者向け医療機関提案レスポンス')

/**
 * 提案された医療機関を承認し、紹介状依頼を作成します。
 * 患者本人かつ自身宛てのpending提案のみ承認可能です。
 * @summary 医療機関提案を承認する
 */
export const PatientAcceptClinicProposalParams = zod.object({
  "proposalId": zod.string().uuid().describe('提案ID')
}).strict()

export const PatientAcceptClinicProposalResponse = zod.object({
  "referralRequestId": zod.string().uuid().describe('紹介状依頼ID（UUID）'),
  "patientId": zod.string().uuid().describe('患者ID（UUID）'),
  "clinicId": zod.string().uuid().describe('依頼先クリニックID（UUID）'),
  "status": zod.enum(['requested', 'mailed']).describe('依頼ステータス'),
  "requestedAt": zod.string().datetime({"offset":true}).describe('依頼日時（RFC3339）'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('患者紹介状依頼')

/**
 * 提案された医療機関を拒否します。
 * 患者本人かつ自身宛てのpending提案のみ拒否可能です。
 * 拒否後、患者は理由選択画面に戻り再度フローを開始できます。
 * @summary 医療機関提案を拒否する
 */
export const PatientRejectClinicProposalParams = zod.object({
  "proposalId": zod.string().uuid().describe('提案ID')
}).strict()

export const patientRejectClinicProposalResponseClinicNameMax = 200;

export const patientRejectClinicProposalResponseClinicDepartmentMax = 200;

export const patientRejectClinicProposalResponseClinicDescriptionMax = 4000;

export const patientRejectClinicProposalResponseClinicAddressMax = 500;

export const patientRejectClinicProposalResponseClinicClosedDaysMax = 200;

export const patientRejectClinicProposalResponseClinicOpeningHoursMondayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursMondayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursMondayDefault = [];
export const patientRejectClinicProposalResponseClinicOpeningHoursTuesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursTuesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursTuesdayDefault = [];
export const patientRejectClinicProposalResponseClinicOpeningHoursWednesdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursWednesdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursWednesdayDefault = [];
export const patientRejectClinicProposalResponseClinicOpeningHoursThursdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursThursdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursThursdayDefault = [];
export const patientRejectClinicProposalResponseClinicOpeningHoursFridayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursFridayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursFridayDefault = [];
export const patientRejectClinicProposalResponseClinicOpeningHoursSaturdayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursSaturdayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursSaturdayDefault = [];
export const patientRejectClinicProposalResponseClinicOpeningHoursSundayItemStartTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursSundayItemEndTimeRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const patientRejectClinicProposalResponseClinicOpeningHoursSundayDefault = [];

export const PatientRejectClinicProposalResponse = zod.object({
  "proposalId": zod.string().uuid().describe('提案ID'),
  "reasonCode": zod.enum(['cannot_find_commutable', 'no_nearby_clinic', 'no_preferred_clinic']).describe('患者が選択した理由'),
  "message": zod.string().optional().describe('オペレーターから患者へのメッセージ'),
  "clinic": zod.object({
  "clinicOrganizationId": zod.string().uuid().describe('クリニック組織ID'),
  "name": zGraphemeString({ max: patientRejectClinicProposalResponseClinicNameMax }).describe('医療機関名'),
  "department": zGraphemeString({ max: patientRejectClinicProposalResponseClinicDepartmentMax }).describe('診療科目'),
  "description": zGraphemeString({ max: patientRejectClinicProposalResponseClinicDescriptionMax }).describe('医療機関説明'),
  "address": zGraphemeString({ max: patientRejectClinicProposalResponseClinicAddressMax }).describe('住所'),
  "closedDays": zGraphemeString({ max: patientRejectClinicProposalResponseClinicClosedDaysMax }).describe('休診日'),
  "openingHours": zod.object({
  "monday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursMondayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursMondayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientRejectClinicProposalResponseClinicOpeningHoursMondayDefault),
  "tuesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursTuesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursTuesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientRejectClinicProposalResponseClinicOpeningHoursTuesdayDefault),
  "wednesday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursWednesdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursWednesdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientRejectClinicProposalResponseClinicOpeningHoursWednesdayDefault),
  "thursday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursThursdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursThursdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientRejectClinicProposalResponseClinicOpeningHoursThursdayDefault),
  "friday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursFridayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursFridayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientRejectClinicProposalResponseClinicOpeningHoursFridayDefault),
  "saturday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursSaturdayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursSaturdayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientRejectClinicProposalResponseClinicOpeningHoursSaturdayDefault),
  "sunday": zod.array(zod.object({
  "startTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursSundayItemStartTimeRegExp.test(v)).describe('開始時刻（HH:mm）'),
  "endTime": zod.string().refine((v) => patientRejectClinicProposalResponseClinicOpeningHoursSundayItemEndTimeRegExp.test(v)).describe('終了時刻（HH:mm）')
}).strict().describe('診療時間の時間帯スロット（開始〜終了のペア）')).default(patientRejectClinicProposalResponseClinicOpeningHoursSundayDefault)
}).strict().describe('曜日別の診療時間設定。各曜日は時間帯スロットの配列（空配列は休診）。')
}).strict().optional().describe('管理外クリニックの詳細情報'),
  "status": zod.enum(['waiting_proposal', 'pending', 'accepted', 'rejected']).describe('提案ステータス'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時')
}).strict().describe('患者向け医療機関提案レスポンス')

